<template>
  <!--Test comment-->
  <div id="details-page">
    <div class="mobile-toolbar mobile-only">
      <div class="search-overview">
        <b
          >{{ searchParameters.itineraries[0].origin.value.code }} -
          {{
            searchParameters.itineraries[
              searchParameters.itineraries.length - 1
            ].destination.value.code
          }}</b
        >
        <br />
        {{ selectedFlights.outbound.formattedDepartureDate }}
      </div>
      <b-button size="is-small" @click="toggleMobileReview()" icon-right="tune"
        >Flight review</b-button
      >
    </div>

    <b-modal
      class="modal-padded"
      :active.sync="isModifySearch"
      has-modal-card
      trap-focus
    >
      <search-engine></search-engine>
    </b-modal>

    <b-modal :active.sync="howItWorksModal" scroll="keep" key="howItWorkModal">
      <div class="card how-it-works-modal">
        <button
          class="modal-close-button"
          @click="howItWorksModal = false"
        ></button>
        <div class="card-content">
          <h2 class="price-heading">How it works</h2>

          <ul class="mt-24">
            <li>
              Select if you would like to redeem Rewards points towards the cost
              of your transaction.
            </li>
            <li>
              If yes, you may choose to redeem points towards 50% or 100% of the
              total booking amount.
            </li>
            <li>
              If you do not have sufficient points given your selection, the
              maximum amount in increments of 5000 points will be redeemed. 5000
              points = R250.
            </li>
            <li>
              First, your booking must be settled in full using your Investec
              Visa card.
            </li>
            <li>
              Your Rewards redemption rebate will then reflect as a credit in
              your Investec Private Bank Account within 48-72 business hours.
            </li>
          </ul>
          <div class="modal-divider mt-24"></div>
          <div class="modal-close-container">
            <div @click="howItWorksModal = false" class="close-button">Ok</div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="mobile-review-modal"
      :active.sync="mobileReviewModal"
      :can-cancel="['escape', 'x', 'outside']"
      full-screen
    >
      <trip-review
        id="trip-review"
        :errors="errors"
        :validationError="validationError"
        :all-passengers="allPassengers"
        foo="testing"
      >
        <!-- <b-button
          class="width-100"
          icon-left="close"
          type="is-primary"
          @click="toggleMobileReview()"
        >Close review</b-button> -->
      </trip-review>
    </b-modal>

    <trip-review
      id="trip-review"
      class="desktop-only"
      :errors="errors"
      :validationError="validationError"
      :all-passengers="allPassengers"
      foo="testing"
    >
    </trip-review>

    <div class="main-content">
      <div class="steps">
        <!-- <div class="block-heading">{{ blockHeading }}</div> -->
        <!-- <div class="width-100 desktop-only">
          <b-steps type="is-primary" v-model="stepBlock" :has-navigation="false">
            <b-step-item icon="account"></b-step-item>
            <b-step-item icon="account-plus"></b-step-item>
            <b-step-item icon="format-list-checkbox"></b-step-item>
            <b-step-item icon="credit-card"></b-step-item>
            <b-step-item icon="check"></b-step-item>
          </b-steps>
        </div> -->
      </div>

      <transition name="rotate-in">
        <form class="block-1" v-if="block == 1">
          <h2 class="block-heading">{{ blockHeading }}</h2>
          <div class="passenger-list">
            <div
              class="container-div"
              v-for="(passenger, index) in adults"
              :key="'adult-' + index"
            >
              <div class="passenger-block" :class="{ first: index === 0 }">
                <h3 class="passenger-type" v-if="passenger.firstName">
                  {{ passenger.title }} {{ passenger.firstName }}
                  {{ passenger.middleName }} {{ passenger.lastName }} (Adult)
                  (16+ years)
                </h3>
                <h3 class="passenger-type" v-else>
                  Adult passenger {{ index + 1 }} (16+ years)
                </h3>
                <div class="flex-row">
                  <CustomDetailsSelect
                    id="passengerTitle"
                    class="max-w-120"
                    v-model="passenger.title"
                    placeholder="Title"
                    :options="titleOptions"
                    type="description"
                    :class="{ 'is-error': passenger.errors.title }"
                    data-cy="passenger-title-select"
                  />
                  <CustomDetailsInput
                    id="passengerFirstName"
                    :value="
                      [passenger.firstName, passenger.middleName]
                        .filter(Boolean)
                        .join(' ')
                    "
                    @input="val => handleNameInput(val, passenger)"
                    placeholder="First name as per ID/passport"
                    class="mt-16"
                    :class="{ 'is-error': passenger.errors.firstName }"
                    data-cy="passenger-first-name-input"
                  />
                </div>
                <CustomDetailsInput
                  id="passengerLastName"
                  v-model="passenger.lastName"
                  placeholder="Last name as per ID/passport"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.lastName }"
                  data-cy="passenger-last-name-input"
                />
                <p
                  v-if="passenger.errors.fullNameTooLong"
                  class="help is-danger"
                >
                  Your first name and last name exceeded the maximum {{ displayMaxCharLimitAllPax }} characters allowance.                </p>
                <div class="mt-16 flex-row day-and-month-of-birth">
                  <CustomDetailsSelect
                    id="passengerBirthDay"
                    v-model="passenger.dob.day"
                    :options="adultDayRange(passenger)"
                    placeholder="Day of
                    birth"
                    :class="{ 'is-error': passenger.errors.day }"
                    class="max-w-180"
                    data-cy="passenger-birth-day-select"
                  />
                  <CustomDetailsSelect
                    id="passengerBirthMonth"
                    v-model="passenger.dob.month"
                    :options="adultMonthRange(passenger)"
                    placeholder="Month of birth"
                    :class="{ 'is-error': passenger.errors.month }"
                    class="max-w-180"
                    type="country"
                    data-cy="passenger-birth-month-select"
                  />
                  <CustomDetailsSelect
                    id="passengerBirthYear"
                    v-model="passenger.dob.year"
                    type="age"
                    :options="adultYearRange(passenger)"
                    placeholder="Year of birth"
                    :class="{ 'is-error': passenger.errors.year }"
                    data-cy="passenger-birth-year-select"
                  />
                </div>
                <p
                  v-if="passenger.errors.dateOfBirthRange"
                  class="help is-danger"
                >
                  Adults must be 16 years or more at return travel date. Please
                  <span
                    style="
                      cursor: pointer;
                      font-weight: bold;
                      text-decoration: underline;
                      color: blue;
                    "
                    v-on:click="isModifySearch = !isModifySearch"
                  >
                    modify search
                  </span>
                  to change passenger type.
                </p>
                <CustomDetailsSelect
                  id="passengerNationality"
                  v-if="isInternational"
                  v-model="passenger.nationality"
                  :options="countrycodes"
                  placeholder="Nationality"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.nationality }"
                  type="country"
                />
                <CustomDetailsInput
                  id="passengerPassportNumber"
                  v-if="isInternational"
                  v-model="passenger.passportNumber"
                  placeholder="Passport number"
                  :class="{ 'is-error': passenger.errors.passportNumber }"
                />
                <CustomDetailsSelect
                  id="passengerPassportCountry"
                  v-if="isInternational"
                  v-model="passenger.passportCountry"
                  :options="countrycodes"
                  placeholder="Passport country"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.passportCountry }"
                  type="country"
                />
                <div
                  v-if="isInternational"
                  class="mt-16 flex-row day-and-month-of-birth"
                >
                  <CustomDetailsSelect
                    id="passengerPassportExpiryDay"
                    v-model="passenger.passportExpiry.day"
                    :options="days"
                    placeholder="Passport Expiry day"
                    :class="{ 'is-error': passenger.errors.pday }"
                    class="max-w-180"
                  />
                  <CustomDetailsSelect
                    id="passengerPassportExpiryMonth"
                    v-model="passenger.passportExpiry.month"
                    :options="monthList"
                    placeholder="Expiry month"
                    :class="{ 'is-error': passenger.errors.pmonth }"
                    class="max-w-180"
                    type="country"
                  />
                  <CustomDetailsSelect
                    id="passengerPassportExpiryYear"
                    v-model="passenger.passportExpiry.year"
                    :options="passportExpiryYears"
                    placeholder="Expiry year"
                    :class="{ 'is-error': passenger.errors.pyear }"
                  />
                </div>
                <!-- Multiple passengers can't have same first and last names -->
                <div class="custom-b-message" v-if="bookingHasIdenticalNames">
                  Due to travel regulations, passengers with identical first and
                  last names cannot appear in the same booking. Please contact
                  us on +27 21 929 2800 for assistance with this booking.
                </div>
                <div
                  class="baggage-section"
                  v-if="
                    priceResponse.baggageOptions.allBaggage.length > 0 &&
                      isEnabledBaggageCarrier
                  "
                >
                  <div
                    class="bag-input"
                    v-for="(bag, index) in allAdultBags"
                    :key="'adultbag-' + index"
                  >
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="
                          passenger.baggageSelection.find(e => e.id == bag.id)
                            .selected
                        "
                      />
                      <span class="checkmark"></span>
                      {{
                        additionalBaggageAllowed
                          ? `Additional ${bag.direction.toLowerCase()}  baggage available to purchase:`
                          : `Add ${bag.direction.toLowerCase()} baggage:`
                      }}
                      {{ bag.description }}
                    </label>
                  </div>
                </div>
                <!-- Special requests -->
                <span v-if="offersMeals || offersFrequentFlyer">
                  <div class="block-divider"></div>
                  <h3 class="block-heading mt-3 mb-3" id="termsAndConditions">
                    Special Requests
                  </h3>
                  <!-- Frequent flyers -->
                  <div
                    class="airline-details mt-16 flex-row"
                    v-if="offersFrequentFlyer"
                  >
                    <b-field class="expanded-field" expanded>
                      <div class="autocomplete-wrapper">
                        <b-autocomplete
                          expanded
                          :data="filteredAirlineCodes"
                          placeholder="Search airline"
                          :field="selectedAirlineDisplayMap['adult-' + index]"
                          :keep-first="true"
                          :open-on-focus="true"
                          autocomplete="false"
                          @typing="
                            query => filterAirlineCodes(query, 'adult-' + index)
                          "
                          v-model="airlineCodeQueryMap['adult-' + index]"
                          class="airline-picker"
                          @select="
                            option =>
                              selectAirline(option, passenger, 'adult-' + index)
                          "
                          @focus="setActivePassenger('adult-' + index)"
                        >
                          <template slot-scope="props">
                            <div class="media">
                              <div class="media-left">
                                <b-icon icon="airplane"></b-icon>
                              </div>
                              <div class="media-content">
                                {{ props.option.name }} ({{
                                  props.option.code
                                }})
                              </div>
                            </div>
                          </template>
                        </b-autocomplete>
                        <div
                          class="clear-button"
                          v-if="airlineCodeQueryMap['adult-' + index]"
                          @click="clearAirlineCodeQuery('adult-' + index)"
                        >
                          <b-icon icon="close" size="is-small"></b-icon>
                        </div>
                        <span
                          class="custom-label-flyer"
                          v-if="airlineCodeQueryMap['adult-' + index]"
                        >
                          Airline
                        </span>
                      </div>
                    </b-field>
                    <CustomDetailsInput
                      v-model="
                        passenger.specialRequests.frequentFlyerDetailsList[0]
                          .frequentFlyerCode
                      "
                      placeholder="Add frequent flyer number"
                      type="flyerNumber"
                    />
                  </div>
                  <!-- Meal requests -->
                  <span v-if="offersMeals" class="mt-16">
                    <CustomDetailsSelect
                      v-model="passenger.specialRequests.mealSelection"
                      :options="formattedMealOptions"
                      type="description"
                      placeholder="Add meal preference"
                      class="max-w-49 mt-3 mb-3"
                      @input="updateMealProduct"
                    />
                    <span style="font-size: 9px"
                      >*Please note: meal requests are not guaranteed by the
                      airline - please check this with the airline directly when
                      booked.</span
                    >
                  </span>
                  <!-- ENDOF Meals-->
                </span>
                <!-- End of special requests -->
              </div>
            </div>
            <div
              class="container-div"
              v-for="(passenger, index) in youngAdults"
              :key="'youngAdult-' + index"
            >
              <div class="passenger-block">
                <h3 class="passenger-type" v-if="passenger.firstName">
                  {{ passenger.title }} {{ passenger.firstName }}
                  {{ passenger.middleName }} {{ passenger.lastName }} (Young
                  adult) (12-15 years)
                </h3>
                <h3 class="passenger-type" v-else>
                  Young adult passenger {{ index + 1 }} (12-15 years)
                </h3>
                <div class="flex-row">
                  <CustomDetailsSelect
                    class="max-w-120"
                    v-model="passenger.title"
                    placeholder="Title"
                    :options="titleOptions"
                    type="description"
                    :class="{ 'is-error': passenger.errors.title }"
                  />
                  <CustomDetailsInput
                    :value="
                      [passenger.firstName, passenger.middleName]
                        .filter(Boolean)
                        .join(' ')
                    "
                    @input="val => handleNameInput(val, passenger)"
                    placeholder="First name as per ID/passport"
                    class="mt-16"
                    :class="{ 'is-error': passenger.errors.firstName }"
                  />
                </div>
                <CustomDetailsInput
                  v-model="passenger.lastName"
                  placeholder="Last name as per ID/passport"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.lastName }"
                />
                <p
                  v-if="passenger.errors.fullNameTooLong"
                  class="help is-danger"
                >
                  Your first name and last name exceeded the maximum {{ displayMaxCharLimitAllPax }} characters allowance.                </p>
                <div class="mt-16 flex-row day-and-month-of-birth">
                  <CustomDetailsSelect
                    v-model="passenger.dob.day"
                    :options="youngAdultDayRange(passenger)"
                    placeholder="Day of birth"
                    :class="{ 'is-error': passenger.errors.day }"
                    class="max-w-180"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.dob.month"
                    :options="youngAdultMonthRange(passenger)"
                    placeholder="Month of birth"
                    :class="{ 'is-error': passenger.errors.month }"
                    class="max-w-180"
                    type="country"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.dob.year"
                    :options="youngAdultYearRange(passenger)"
                    placeholder="Year of birth"
                    :class="{ 'is-error': passenger.errors.year }"
                  />
                </div>
                <p
                  v-if="passenger.errors.dateOfBirthRange"
                  class="help is-danger"
                >
                  Young adults must be between 12 and 16 years old at return
                  travel date. Please
                  <span
                    style="
                      cursor: pointer;
                      font-weight: bold;
                      text-decoration: underline;
                      color: blue;
                    "
                    v-on:click="isModifySearch = !isModifySearch"
                  >
                    modify search
                  </span>
                  to change passenger type.
                </p>
                <CustomDetailsSelect
                  v-if="isInternational"
                  v-model="passenger.nationality"
                  :options="countrycodes"
                  placeholder="Nationality"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.nationality }"
                  type="country"
                />
                <CustomDetailsInput
                  v-if="isInternational"
                  v-model="passenger.passportNumber"
                  placeholder="Passport number"
                  :class="{ 'is-error': passenger.errors.passportNumber }"
                />
                <CustomDetailsSelect
                  v-if="isInternational"
                  v-model="passenger.passportCountry"
                  :options="countrycodes"
                  placeholder="Passport country"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.passportCountry }"
                  type="country"
                />
                <div
                  v-if="isInternational"
                  class="mt-16 flex-row day-and-month-of-birth"
                >
                  <CustomDetailsSelect
                    v-model="passenger.passportExpiry.day"
                    :options="days"
                    placeholder="Passport Expiry day"
                    :class="{ 'is-error': passenger.errors.pday }"
                    class="max-w-180"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.passportExpiry.month"
                    :options="monthList"
                    placeholder="Expiry month"
                    :class="{ 'is-error': passenger.errors.pmonth }"
                    class="max-w-180"
                    type="country"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.passportExpiry.year"
                    :options="passportExpiryYears"
                    placeholder="Expiry year"
                    :class="{ 'is-error': passenger.errors.pyear }"
                  />
                </div>
                <!-- Multiple passengers can't have same first and last names -->
                <div class="custom-b-message" v-if="bookingHasIdenticalNames">
                  Due to travel regulations, passengers with identical first and
                  last names cannot appear in the same booking. Please contact
                  us on +27 21 929 2800 for assistance with this booking.
                </div>
                <div
                  class="baggage-section"
                  v-if="priceResponse.baggageOptions.allBaggage.length > 0"
                >
                  <div
                    class="bag-input"
                    v-for="(bag, index) in allAdultBags"
                    :key="'adultbag-' + index"
                  >
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="
                          passenger.baggageSelection.find(e => e.id == bag.id)
                            .selected
                        "
                      />
                      <span class="checkmark"></span>
                      {{
                        additionalBaggageAllowed
                          ? `Additional ${bag.direction.toLowerCase()}  baggage available to purchase:`
                          : `Add ${bag.direction.toLowerCase()} baggage:`
                      }}
                      {{ bag.description }}
                    </label>
                  </div>
                </div>
                <!-- Special requests -->
                <span v-if="offersMeals || offersFrequentFlyer">
                  <div class="block-divider"></div>
                  <h3 class="block-heading mt-3 mb-3" id="termsAndConditions">
                    Special Requests
                  </h3>
                  <!-- Frequent flyers -->
                  <div
                    class="airline-details mt-16 flex-row"
                    v-if="offersFrequentFlyer"
                  >
                    <b-field class="expanded-field" expanded>
                      <div class="autocomplete-wrapper">
                        <b-autocomplete
                          expanded
                          :data="filteredAirlineCodes"
                          placeholder="Search airline"
                          :field="
                            selectedAirlineDisplayMap['youngAdult-' + index]
                          "
                          :keep-first="true"
                          :open-on-focus="true"
                          autocomplete="false"
                          @typing="
                            query =>
                              filterAirlineCodes(query, 'youngAdult-' + index)
                          "
                          v-model="airlineCodeQueryMap['youngAdult-' + index]"
                          class="airline-picker"
                          @select="
                            option =>
                              selectAirline(
                                option,
                                passenger,
                                'youngAdult-' + index
                              )
                          "
                          @focus="setActivePassenger('youngAdult-' + index)"
                        >
                          <template slot-scope="props">
                            <div class="media">
                              <div class="media-left">
                                <b-icon icon="airplane"></b-icon>
                              </div>
                              <div class="media-content">
                                {{ props.option.name }} ({{
                                  props.option.code
                                }})
                              </div>
                            </div>
                          </template>
                        </b-autocomplete>
                        <div
                          class="clear-button"
                          v-if="airlineCodeQueryMap['youngAdult-' + index]"
                          @click="clearAirlineCodeQuery('youngAdult-' + index)"
                        >
                          <b-icon icon="close" size="is-small"></b-icon>
                        </div>
                        <span
                          class="custom-label-flyer"
                          v-if="airlineCodeQueryMap['youngAdult-' + index]"
                        >
                          Airline
                        </span>
                      </div>
                    </b-field>
                    <CustomDetailsInput
                      v-model="
                        passenger.specialRequests.frequentFlyerDetailsList[0]
                          .frequentFlyerCode
                      "
                      placeholder="Add frequent flyer number"
                      type="flyerNumber"
                    />
                  </div>
                  <!-- Meal requests -->
                  <!-- <span v-if="offersMeals" class="mt-16">
                    <CustomDetailsSelect
                      v-model="passenger.specialRequests.mealSelection"
                      :options="formattedMealOptions"
                      type="description"
                      placeholder="Add meal preference"
                      class="max-w-49 mt-3 mb-3"
                      @input="updateMealProduct"
                    />
                    <span style="font-size: 9px"
                      >*Please note: meal requests are not guaranteed by the
                      airline - please check this with the airline directly when
                      booked.</span
                    >
                  </span> -->
                  <!-- ENDOF Meals-->
                </span>
                <!-- End of special requests -->
              </div>
            </div>
            <div
              class="container-div"
              v-for="(passenger, index) in children"
              :key="'child-' + index"
            >
              <div class="passenger-block">
                <h3 class="passenger-type" v-if="passenger.firstName">
                  {{ passenger.title }} {{ passenger.firstName }}
                  {{ passenger.middleName }} {{ passenger.lastName }} (Child)
                  (2-11 years)
                </h3>
                <h3 class="passenger-type" v-else>
                  Child passenger {{ index + 1 }} (2-11 years)
                </h3>
                <div class="flex-row">
                  <CustomDetailsSelect
                    class="max-w-120"
                    v-model="passenger.title"
                    placeholder="Title"
                    :options="titleOptions"
                    type="description"
                    :class="{ 'is-error': passenger.errors.title }"
                  />
                  <CustomDetailsInput
                    :value="
                      [passenger.firstName, passenger.middleName]
                        .filter(Boolean)
                        .join(' ')
                    "
                    @input="val => handleNameInput(val, passenger)"
                    placeholder="First name as per ID/passport"
                    class="mt-16"
                    :class="{ 'is-error': passenger.errors.firstName }"
                  />
                </div>
                <CustomDetailsInput
                  v-model="passenger.lastName"
                  placeholder="Last name as per ID/passport"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.lastName }"
                />
                <p
                  v-if="passenger.errors.fullNameTooLong"
                  class="help is-danger"
                >
                  Your first name and last name exceeded the maximum {{ displayMaxCharLimitAllPax }} characters allowance.
                </p>
                <div class="mt-16 flex-row day-and-month-of-birth">
                  <CustomDetailsSelect
                    v-model="passenger.dob.day"
                    :options="childDayRange(passenger)"
                    placeholder="Day of birth"
                    :class="{ 'is-error': passenger.errors.day }"
                    class="max-w-180"
                    passengerType="CHILD"
                    :lastDateOfTravel="lastDateOfTravel"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.dob.month"
                    :options="childMonthRange(passenger)"
                    placeholder="Month of birth"
                    :class="{ 'is-error': passenger.errors.month }"
                    class="max-w-180"
                    type="country"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.dob.year"
                    :options="childYearRange(passenger)"
                    placeholder="Year of birth"
                    :class="{ 'is-error': passenger.errors.year }"
                  />
                </div>
                <p
                  v-if="passenger.errors.dateOfBirthRange"
                  class="help is-danger"
                >
                  Children must be between 2 and 11 years old at return travel
                  date. Please
                  <span
                    style="
                      cursor: pointer;
                      font-weight: bold;
                      text-decoration: underline;
                      color: blue;
                    "
                    v-on:click="isModifySearch = !isModifySearch"
                  >
                    modify search
                  </span>
                  to change passenger type.
                </p>
                <CustomDetailsSelect
                  v-if="isInternational"
                  v-model="passenger.nationality"
                  :options="countrycodes"
                  placeholder="Nationality"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.nationality }"
                  type="country"
                />
                <CustomDetailsInput
                  v-if="isInternational"
                  v-model="passenger.passportNumber"
                  placeholder="Passport number"
                  :class="{ 'is-error': passenger.errors.passportNumber }"
                />
                <CustomDetailsSelect
                  v-if="isInternational"
                  v-model="passenger.passportCountry"
                  :options="countrycodes"
                  placeholder="Passport country"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.passportCountry }"
                  type="country"
                />
                <div
                  v-if="isInternational"
                  class="mt-16 flex-row day-and-month-of-birth"
                >
                  <CustomDetailsSelect
                    v-model="passenger.passportExpiry.day"
                    :options="days"
                    placeholder="Passport Expiry day"
                    :class="{ 'is-error': passenger.errors.pday }"
                    class="max-w-180"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.passportExpiry.month"
                    :options="monthList"
                    placeholder="Expiry month"
                    :class="{ 'is-error': passenger.errors.pmonth }"
                    class="max-w-180"
                    type="country"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.passportExpiry.year"
                    :options="passportExpiryYears"
                    placeholder="Expiry year"
                    :class="{ 'is-error': passenger.errors.pyear }"
                  />
                </div>
                <!-- Multiple passengers can't have same first and last names -->
                <div class="custom-b-message" v-if="bookingHasIdenticalNames">
                  Due to travel regulations, passengers with identical first and
                  last names cannot appear in the same booking. Please contact
                  us on +27 21 929 2800 for assistance with this booking.
                </div>
                <div
                  class="baggage-section"
                  v-if="priceResponse.baggageOptions.allBaggage.length > 0"
                >
                  <div
                    class="bag-input"
                    v-for="(bag, index) in allChildBags"
                    :key="'adultbag-' + index"
                  >
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="
                          passenger.baggageSelection.find(e => e.id == bag.id)
                            .selected
                        "
                      />
                      <span class="checkmark"></span>
                      {{
                        additionalBaggageAllowed
                          ? `Additional ${bag.direction.toLowerCase()}  baggage available to purchase:`
                          : `Add ${bag.direction.toLowerCase()} baggage:`
                      }}
                      {{ bag.description }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="container-div"
              v-for="(passenger, index) in infants"
              :key="'infant-' + index"
            >
              <div class="passenger-block">
                <h3 class="passenger-type" v-if="passenger.firstName">
                  {{ passenger.title }} {{ passenger.firstName }}
                  {{ passenger.middleName }} {{ passenger.lastName }} (Infant)
                  (0-23 months)
                </h3>
                <h3 class="passenger-type" v-else>
                  Infant passenger {{ index + 1 }} (0-23 months)
                </h3>
                <div class="flex-row">
                  <CustomDetailsSelect
                    class="max-w-120"
                    v-model="passenger.title"
                    placeholder="Title"
                    :options="titleOptions"
                    type="description"
                    :class="{ 'is-error': passenger.errors.title }"
                  />
                  <CustomDetailsInput
                    :value="
                      [passenger.firstName, passenger.middleName]
                        .filter(Boolean)
                        .join(' ')
                    "
                    @input="val => handleNameInput(val, passenger)"
                    placeholder="First name as per ID/passport"
                    class="mt-16"
                    :class="{ 'is-error': passenger.errors.firstName }"
                  />
                </div>
                <CustomDetailsInput
                  v-model="passenger.lastName"
                  placeholder="Last name as per ID/passport"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.lastName }"
                />
                <p
                  v-if="passenger.errors.fullNameTooLong"
                  class="help is-danger"
                >
                  Your first name and last name exceeded the maximum {{ displayMaxCharLimitAllPax }} characters allowance.                </p>
                <div class="mt-16 flex-row day-and-month-of-birth">
                  <CustomDetailsSelect
                    v-model="passenger.dob.day"
                    :options="infantDayRange(passenger)"
                    placeholder="Day of birth"
                    :class="{ 'is-error': passenger.errors.day }"
                    class="max-w-180"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.dob.month"
                    :options="infantMonthRange(passenger)"
                    placeholder="Month of birth"
                    :class="{ 'is-error': passenger.errors.month }"
                    class="max-w-180"
                    type="country"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.dob.year"
                    :options="infantYearRange(passenger)"
                    placeholder="Year of birth"
                    :class="{ 'is-error': passenger.errors.year }"
                  />
                </div>
                <p
                  v-if="passenger.errors.dateOfBirthRange"
                  class="help is-danger"
                >
                  Infants must be between 0 and 23 months at return travel date.
                  Please
                  <span
                    style="
                      cursor: pointer;
                      font-weight: bold;
                      text-decoration: underline;
                      color: blue;
                    "
                    v-on:click="isModifySearch = !isModifySearch"
                  >
                    modify search
                  </span>
                  to change passenger type.
                </p>
                <CustomDetailsSelect
                  v-if="isInternational"
                  v-model="passenger.nationality"
                  :options="countrycodes"
                  placeholder="Nationality"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.nationality }"
                  type="country"
                />
                <CustomDetailsInput
                  v-if="isInternational"
                  v-model="passenger.passportNumber"
                  placeholder="Passport number"
                  :class="{ 'is-error': passenger.errors.passportNumber }"
                />
                <CustomDetailsSelect
                  v-if="isInternational"
                  v-model="passenger.passportCountry"
                  :options="countrycodes"
                  placeholder="Passport country"
                  class="mt-16"
                  :class="{ 'is-error': passenger.errors.passportCountry }"
                  type="country"
                />
                <div
                  v-if="isInternational"
                  class="mt-16 flex-row day-and-month-of-birth"
                >
                  <CustomDetailsSelect
                    v-model="passenger.passportExpiry.day"
                    :options="days"
                    placeholder="Passport Expiry day"
                    :class="{ 'is-error': passenger.errors.pday }"
                    class="max-w-180"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.passportExpiry.month"
                    :options="monthList"
                    placeholder="Expiry month"
                    :class="{ 'is-error': passenger.errors.pmonth }"
                    class="max-w-180"
                    type="country"
                  />
                  <CustomDetailsSelect
                    v-model="passenger.passportExpiry.year"
                    :options="passportExpiryYears"
                    placeholder="Expiry year"
                    :class="{ 'is-error': passenger.errors.pyear }"
                  />
                </div>
                <!-- Multiple passengers can't have same first and last names -->
                <div class="custom-b-message" v-if="bookingHasIdenticalNames">
                  Due to travel regulations, passengers with identical first and
                  last names cannot appear in the same booking. Please contact
                  us on +27 21 929 2800 for assistance with this booking.
                </div>
                <!-- Max Booking Character Length Modal -->
                <div
                  class="custom-b-message"
                  v-if="maxBookingCharacterLengthError"
                >
                    The booking name details have exceeded our max {{ displayMaxCharLimitInfant }} characters
                    limit. Please contact us on +27 21 929 2800
                    for assistance.
                </div>
              </div>
            </div>
          </div>
          <div class="block-navigation-wrapper">
            <div class="block-navigation back">
              <div v-on:click="backPage()">
                <b-icon icon="chevron-left" type="is-brand"> </b-icon>
                <span>Back</span>
              </div>
            </div>
            <div class="block-navigation next">
              <div v-on:click="validateBlock1()" data-cy="passenger-details-next-button">
                <span>Next</span>
              </div>
            </div>
          </div>
        </form>
      </transition>

      <transition name="rotate-in">
        <form class="block-2" v-if="block == 2">
          <h2 class="block-heading">{{ blockHeading }}</h2>
          <div class="passenger-block">
            <b-field
              class="no-wrap"
              label="Payer same as passenger 1:"
              horizontal
            >
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  id="samePayer"
                  v-model="payerSameAsPassenger"
                  data-cy="same-as-passenger-checkbox"
                />
                <span class="checkmark"></span>
              </label>
            </b-field>
            <div class="flex-row">
              <CustomDetailsSelect
                id="payerTitle"
                class="max-w-120"
                v-model="payer.title"
                placeholder="Title"
                :options="titleOptions"
                type="description"
                :class="{ 'is-error': payer.errors.title }"
                data-cy="payer-title-select"
              />
              <CustomDetailsInput
                id="payerFirstName"
                v-model="payer.firstName"
                placeholder="First name as per ID/passport"
                class="mt-16"
                :class="{ 'is-error': payer.errors.firstName }"
                data-cy="payer-first-name-input"
              />
            </div>
            <CustomDetailsInput
              id="payerLastName"
              v-model="payer.lastName"
              placeholder="Last name as per ID/passport"
              class="mt-16"
              :class="{ 'is-error': payer.errors.lastName }"
              data-cy="payer-last-name-input"
            />
            <CustomDetailsInput
              v-model="payer.email"
              placeholder="Email address"
              class="mt-16"
              type="email"
              :class="{
                'is-error': payer.errors.email || payer.errors.isValidEmail
              }"
              id="payerEmailAddress"
              data-cy="payer-email-input"
            />

            <!-- <vue-tel-input
              v-model="payer.mobileNumber"
              expanded
              required
              @country-changed="payerCountryChanged"
              :preferredCountries="['ZA']"
              :mode="'international'"
              :inputOptions="{ showDialCode: true}"
              :class="{
                'is-error': payer.errors.mobileNumber || payer.errors.isValidMobileNumber
              }"
            ></vue-tel-input> -->

            <CustomDetailsInput
              v-model="payer.mobileNumber"
              placeholder="Mobile number"
              class="mt-16"
              type="tel"
              :class="{
                'is-error':
                  payer.errors.mobileNumber || payer.errors.isValidMobileNumber
              }"
              id="payerMobileNumber"
              data-cy="payer-mobile-input"
            />

          </div>
          <div class="block-navigation-wrapper">
            <div class="block-navigation back">
              <div v-on:click="back()">
                <b-icon icon="chevron-left" type="is-brand"> </b-icon>
                <span>Back</span>
              </div>
            </div>
            <div class="block-navigation next">
                <div v-on:click="validateBlock2()" data-cy="payer-details-next-button">
                <span>Next</span>
              </div>
            </div>
          </div>
        </form>
      </transition>

      <transition name="rotate-in">
        <form :class="{ 'block-4': block == 4 }" v-if="block == 4">
          <h2 class="block-heading">{{ blockHeading }}</h2>
          <div class="passenger-block no-borders">
            <div class="redeem-points-block">
              <h1 class="redeem-heading">
                <span :class="showRedeemDetails ? 'is-color' : ''">
                  Redeem your Investec Rewards points
                </span>
              </h1>

              <div class="mt-24" v-if="showRedeemDetails">
                <div class="redeem-description">
                  You may only redeem Rewards points if you are a primary
                  account holder and are registered for the Investec Rewards
                  Programme. (Youth Accounts do not have access to Investec
                  Rewards.)
                </div>

                <div class="how-it-works mt-24" @click="howItWorksModal = true">
                  (How it works?)
                </div>

                <div class="flex-col mt-24">
                  <b-field>
                    <b-radio
                      v-model="redeemPercentage"
                      name="redeemPercentage"
                      :native-value="0"
                      >I do not wish to redeem</b-radio
                    >
                  </b-field>
                  <b-field>
                    <b-radio
                      v-model="redeemPercentage"
                      name="redeemPercentage"
                      native-value="50%"
                      >Redeem my Rewards points toward 50% of my booking
                      amount</b-radio
                    >
                  </b-field>
                  <b-field>
                    <b-radio
                      v-model="redeemPercentage"
                      name="redeemPercentage"
                      native-value="100%"
                      >Redeem my Rewards points toward 100% of my booking
                      amount</b-radio
                    >
                  </b-field>
                </div>
              </div>

              <div class="redeem-divider mt-24"></div>
            </div>

            <!-- <credit-card-form ref="ccform"></credit-card-form> -->
            <div class="visa-logo">
              <img
                src="@/assets/images/logos/Visa_Brandmark_Blue_RGB_2021.png"
                alt="visa logo"
              />
              Pay instantly and securely with your Investec Visa card.
            </div>
            <div class="flex-row" id="cardPaymentWrapper">
              <CustomDetailsInput
              v-model="cardDetails.nameOnCard"
              placeholder="Cardholder name"
              id="payerLastName"
              :class="{ 'is-error': cardDetails.errors.nameOnCard }"
              data-cy="card-name-input"
              />
              <p v-if="cardDetails.errors.nameOnCard" class="error-message">
              The name is missing or invalid
              </p>
            </div>
            <CustomDetailsInput
              class="mt-16"
              v-model="cardDetails.cardNumber"
              type="card"
              @resetCardValidation="resetCardValidation"
              placeholder="Card number"
              :class="{ 'is-error': cardDetails.errors.cardNumber }"
              id="cardNumber"
              data-cy="card-number-input"
            />
            <p v-if="cardDetails.errors.cardNumber" class="error-message">
              Your card number is missing or invalid
            </p>
            <!-- Desktop Card Fields -->
            <div class="desktop-card-field-wrapper mt-16 flex-row">
              <CustomDetailsInput
                v-model="cardDetails.cvv"
                placeholder="CVV"
                :class="{ 'is-error': cardDetails.errors.cvv }"
                data-cy="card-cvv-input"
              />
              <CustomDetailsSelect
                v-model="cardDetails.expiryMonth"
                :options="monthList"
                placeholder="Month"
                :class="{
                  'is-error':
                    cardDetails.errors.expiryMonth ||
                    cardDetails.errors.expiryDate
                }"
                id="cardExpiryMonth"
                type="country"
                data-cy="card-expiry-month-select"
              />
              <CustomDetailsSelect
                v-model="cardDetails.expiryYear"
                :options="cardYears"
                placeholder="Year"
                :class="{
                  'is-error':
                    cardDetails.errors.expiryYear ||
                    cardDetails.errors.expiryDate
                }"
                id="cardYear"
                data-cy="card-expiry-year-select"
              />
            </div>
            <!-- Mobile Card Fields -->
            <div class="mobile-card-field-wrapper">
              <CustomDetailsInput
                v-model="cardDetails.cvv"
                placeholder="CVV"
                :class="{ 'is-error': cardDetails.errors.cvv }"
                data-cy="mobile-card-cvv-input"
              />
              <CustomDetailsSelect
                v-model="cardDetails.expiryMonth"
                :options="monthList"
                placeholder="Month"
                :class="{ 'is-error': cardDetails.errors.expiryMonth }"
                id="cardExpiryMonth"
                type="country"
                data-cy="mobile-card-expiry-month-select"
              />
              <CustomDetailsSelect
                v-model="cardDetails.expiryYear"
                :options="cardYears"
                placeholder="Year"
                :class="{ 'is-error': cardDetails.errors.expiryYear }"
                id="cardYear"
                data-cy="mobile-card-expiry-year-select"
              />
            </div>

            <p v-if="cardDetails.errors.cvv" class="error-message">
                The cvv number is missing or invalid
              </p>

            <p v-if="cardDetails.errors.expiryMonth || cardDetails.errors.expiryYear" class="error-message">
              The expiry date is missing or invalid
            </p>

            <p v-if="cardDetails.errors.expiryDate" class="error-message">
              Your card is expired. Please use a valid card.
            </p>

            <div v-if="paymentOptionCost" class="payment-option-charge">
              + R{{ paymentOptionCost }} payment method fee
            </div>

            <div class="redeem-divider mt-24 mb-10"></div>

            <!-- VAT Details -->
            <div>
              <label class="custom-checkbox-2" expanded>
                <input type="checkbox" v-model="billingDetails.vatInvoice" data-cy="vat-invoice-checkbox" />
                <span class="checkmark"></span>
                  <small style="font-weight: bold; font-family: Inter;">VAT invoice in a company name</small>
              </label>
            </div>
            <CustomDetailsInput
              v-if="billingDetails.vatInvoice"
              v-model="billingDetails.companyName"
              id="companyName"
              placeholder="Company name"
              expanded
              required
              type="country"
              :class="{ 'is-error': billingDetails.errors.companyName }"
              :isMandatory="true"
              data-cy="company-name-input"
            />
            <CustomDetailsInput
              v-if="billingDetails.vatInvoice"
              placeholder="Company VAT No"
              v-model="billingDetails.companyVatNo" 
              id="companyVatNo"
              expanded
              required
              type="country"
              :class="{ 'is-error': billingDetails.errors.companyVatNo }"
              data-cy="company-vatno-input"
            />
            <!-- Billing Details Block -->
            <h2 class="block-heading">Billing address</h2>
            <CustomDetailsInput
              v-model="billingDetails.addressLine1"
              id="billingDetails" 
              placeholder="Address line 1"
              :class="{ 'is-error': billingDetails.errors.addressLine1 }"
              :isMandatory="true"
              required
              data-cy="billing-address1-input"
            />
            <CustomDetailsInput
              v-model="billingDetails.addressLine2"
              placeholder="Address line 2"
              data-cy="billing-address2-input"
            />
            <CustomDetailsInput
              v-model="billingDetails.postalCode"
              placeholder="Postal code"
              :class="{ 'is-error': billingDetails.errors.postalCode }"
              :isMandatory="true"
              required
              data-cy="billing-postalcode-input"
            />
            <CustomDetailsInput
              v-model="billingDetails.city"
              placeholder="City"
              :class="{ 'is-error': billingDetails.errors.city }"
              :isMandatory="true"
              required
              data-cy="billing-city-input"
            />
            <CustomDetailsSelect
              v-model="billingDetails.country"
              :options="countries"
              placeholder="Country"
              type="country"
              :class="{ 'is-error': cardDetails.errors.expiryYear }"
              data-cy="billing-country-select"
            />
            <div class="redeem-divider mt-24"></div>
            <h3 class="block-heading" id="termsAndConditions">
              Terms and conditions
            </h3>
            <transition name="slide-in-top">
              <div class="flex-col">
                <div class="search-blurb-wrapper">
                  <small>
                    Before booking your flight(s), please ensure you are
                    compliant with the relevant visa and health-related
                    regulations (including Covid-19) at your destination
                    country, as well as any countries you may be transiting
                    through. For more information,
                    <a
                      @click="
                        invsyLink(
                          'https://apply.joinsherpa.com/travel-restrictions'
                        )
                      "
                      >please visit Sherpa</a
                    >.
                    <!-- or the
                    <a @click="invsyLink('https://www.iatatravelcentre.com/passport-visa-health-travel-document-requirements.htm')"
                      >International Air Transport Association’s Travel Centre</a
                    >. -->
                  </small>
                </div>
                <b-field
                  :type="{ 'is-danger': airRulesError }"
                  :message="{
                    'Please acknowledge that you have read and accept the airline rules.': airRulesError
                  }"
                >
                  <label class="custom-checkbox">
                    <input type="checkbox" v-model="airRulesCheck" data-cy="airline-rules-checkbox" />
                    <span class="checkmark"></span>
                    <small
                      >I confirm I have read and accept the air rules, which are
                      binding, as specified by the airline(s) of my
                      choice.</small
                    >
                  </label>
                </b-field>
                <b-field
                  :type="{ 'is-danger': termsError }"
                  :message="{
                    'Please acknowledge that you have read and accept the terms and conditions.': termsError
                  }"
                >
                  <label class="custom-checkbox">
                    <input type="checkbox" v-model="termsAgreed" data-cy="terms-and-conditions-checkbox" />
                    <span class="checkmark"></span>
                    <small
                      >I confirm that I have checked the transit and entry
                      requirements of my destination country and I have read and
                      understand the
                      <a
                        @click="
                          invsyLink(
                            'https://www.investectravel.com/terms-and-conditions/'
                          )
                        "
                        >terms and conditions</a
                      >
                      of my booking.</small
                    >
                  </label>
                </b-field>
              </div>
            </transition>
          </div>
          <div class="block-navigation-wrapper">
            <div class="block-navigation back">
              <div v-on:click="back(4)">
                <b-icon icon="chevron-left" type="is-brand"> </b-icon>
                <span>Back</span>
              </div>
            </div>
            <div class="block-navigation next">
              <div
                v-on:click="validateBlock4()"
                data-cy="payment-details-next-button"
                :disabled="!termsAgreed || !airRulesCheck"
                >
                <span>Pay now</span>
              </div>
            </div>
          </div>
        </form>
      </transition>
    </div>
  </div>
</template>

<script>
import Api from "../services/Api.service.js";
import { mapState } from "vuex";
import moment from "moment";
import { VueTelInput } from "vue-tel-input";
import CreditCardForm from "@/components/CreditCardForm.vue";
import TripReview from "@/components/TripReview.vue";
import CountryCodes from "@/services/CountryCodesShort.service.js";
import AirlineCodes from "@/services/AirlineCodes.service.js";
import MonthList from "@/services/MonthList.service.js";
import SearchEngine from "@/components/SearchEngine.vue";
import Loader from "@/components/Loader.vue";
import PaymentMethodsLoader from "@/components/PaymentMethodsLoader.vue";
import { cloneDeep } from "lodash";
import CustomDetailsSelect from "@/components/CustomDetailsSelect.vue";
import CustomDetailsInput from "@/components/CustomDetailsInput.vue";
import CustomDetailsDatepicker from "@/components/CustomDetailsDatepicker.vue";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { locations } from "@/assets/json/locations.json";
import { applyDomesticPassportPlaceholders } from "@/utils/domesticPassenger";
import {
  validateName as validatePassengerName,
  validateMiddleName as validatePassengerMiddleName,
  validateMaxCharLengthOnPassenger as isPassengerNameWithinCharLimit,
  validateMaxLengthForInfantBookings as isInfantBookingNameWithinCharLimit,
  PASSENGER_NAME_CHAR_LIMIT,
  STANDARD_NAME_BUFFER,
  INFANT_COMBINED_NAME_BUFFER
} from "@/utils/passengerValidation";

dayjs.extend(customParseFormat);

export default {
  name: "details-list",
  data: function() {
    const today = new Date();
    return {
      block: 1,
      titleOptions: [
        { description: "Mr", code: "Mr" },
        { description: "Mrs", code: "Mrs" },
        { description: "Ms", code: "Ms" },
        { description: "Miss", code: "Miss" }
      ],
      showRedeemDetails: true,
      howItWorksModal: false,
      mealOptions: [
        {
          code: null,
          description: "NONE"
        },
        {
          code: "BBML",
          description: "BABY MEAL"
        },
        {
          code: "BLML",
          description: "BLAND MEAL"
        },
        {
          code: "CHML",
          description: "CHILD MEAL"
        },
        {
          code: "DBML",
          description: "DIABETIC MEAL"
        },
        {
          code: "GFML",
          description: "GLUTEN FREE MEAL"
        },
        {
          code: "KSML",
          description: "KOSHER MEAL"
        },
        {
          code: "MOML",
          description: "HALAL MEAL"
        },
        {
          code: "NLML",
          description: "LOW LACTOSE MEAL"
        },
        {
          code: "VGML",
          description: "VEGAN MEAL"
        },
        {
          code: "VLML",
          description: "VEGETARIAN MEAL"
        }
      ],
      mobileReviewModal: false,
      payerSameAsPassenger: false,
      errors: [],
      focusedDate: new Date(
        today.getFullYear() - 12,
        today.getMonth(),
        today.getDate()
      ),
      focusedDate2: new Date(
        today.getFullYear() - 2,
        today.getMonth(),
        today.getDate() - 1
      ),
      adults: [],
      youngAdults: [],
      children: [],
      infants: [],
      paymentOption: "",
      paymentMethod: undefined,
      termsAgreed: false,
      termsError: false,
      airRulesCheck: false,
      airRulesError: false,
      payer: {
        title: null,
        email: null,
        firstName: null,
        lastName: null,
        mobileNumber: null,
        mobileCode: "27",
        errors: []
      },
      billingDetails: {
        addressLine1: undefined,
        addressLine2: undefined,
        postalCode: undefined,
        city: undefined,
        country: "ZA",
        contactCode: "27",
        contactNo: undefined,
        vatInvoice: false,
        companyName: undefined, //this is now used for company Vat name
        webpackHotUpdate: process.env.NODE_ENV === "development" ? true : false,
        companyVatNo: undefined,
        errors: []
      },
      labelPosition: null,
      loaderOpen: false,
      paymentMethodResults: undefined,
      paymentMethodComplete: false,
      validationError: false,
      redeemPercentage: 0,
      isModifySearch: false,
      days: [...Array(31).keys()].map(e => e + 1),
      cardYears: [...Array(10).keys()].map(e => e + new Date().getFullYear()),
      passportExpiryYears: [...Array(20).keys()].map(
        e => e + new Date().getFullYear()
      ),
      cardDetails: {
        nameOnCard: undefined,
        cardNumber: undefined,
        cvv: undefined,
        expiryMonth: undefined,
        expiryYear: undefined,
        errors: []
      },
      frequentFlyerCode: null,
      countries: [
        { code: "ZA", name: "South Africa" },
        { code: "AF", name: "Afghanistan" },
        { code: "AX", name: "Åland Islands" },
        { code: "AL", name: "Albania" },
        { code: "DZ", name: "Algeria" },
        { code: "AS", name: "American Samoa" },
        { code: "AD", name: "Andorra" },
        { code: "AO", name: "Angola" },
        { code: "AI", name: "Anguilla" },
        { code: "AQ", name: "Antarctica" },
        { code: "AG", name: "Antigua and Barbuda" },
        { code: "AR", name: "Argentina" },
        { code: "AM", name: "Armenia" },
        { code: "AW", name: "Aruba" },
        { code: "AU", name: "Australia" },
        { code: "AT", name: "Austria" },
        { code: "AZ", name: "Azerbaijan" },
        { code: "BS", name: "Bahamas" },
        { code: "BH", name: "Bahrain" },
        { code: "BD", name: "Bangladesh" },
        { code: "BB", name: "Barbados" },
        { code: "BY", name: "Belarus" },
        { code: "BE", name: "Belgium" },
        { code: "BZ", name: "Belize" },
        { code: "BJ", name: "Benin" },
        { code: "BM", name: "Bermuda" },
        { code: "BT", name: "Bhutan" },
        { code: "BO", name: "Bolivia, Plurinational State of" },
        { code: "BQ", name: "Bonaire, Sint Eustatius and Saba" },
        { code: "BA", name: "Bosnia and Herzegovina" },
        { code: "TG", name: "Togo" },
        { code: "TK", name: "Tokelau" },
        { code: "TT", name: "Trinidad and Tobago" },
        { code: "TO", name: "Tonga" },
        { code: "TN", name: "Tunisia" },
        { code: "TR", name: "Turkey" },
        { code: "TM", name: "Turkmenistan" },
        { code: "TC", name: "Turks and Caicos Islands" },
        { code: "TV", name: "Tuvalu" },
        { code: "UG", name: "Uganda" },
        { code: "UA", name: "Ukraine" },
        { code: "AE", name: "United Arab Emirates" },
        { code: "GB", name: "United Kingdom" },
        { code: "US", name: "United States" },
        { code: "UM", name: "United States Minor Outlying Islands" },
        { code: "UY", name: "Uruguay" },
        { code: "UZ", name: "Uzbekistan" },
        { code: "VU", name: "Vanuatu" },
        { code: "VE", name: "Venezuela, Bolivarian Republic of" },
        { code: "VN", name: "Viet Nam" },
        { code: "VG", name: "Virgin Islands, British" },
        { code: "VI", name: "Virgin Islands, U.S." },
        { code: "WF", name: "Wallis and Futuna" },
        { code: "EH", name: "Western Sahara" },
        { code: "YE", name: "Yemen" },
        { code: "ZM", name: "Zambia" },
        { code: "ZW", name: "Zimbabwe" }
      ],
      baggageEnabledCarriers: ["LH", "AF", "KL", "LX"],
      bookBody: {},
      maxBookingCharacterLengthError: false,
      airlineCodesFlyer: AirlineCodes,
      airlineCodeQueryMap: {},
      activePassengerKey: null,
      selectedAirlineDisplayMap: {},
      allAirports: locations,
      displayMaxCharLimitAllPax: null,
      displayMaxCharLimitInfant: null,
    };
  },
  computed: {
    ...mapState([
      "selectedFlights",
      "flags",
      "priceResponse",
      "searchParameters",
      "products",
      "paymentMethodResponse",
      "paymentOptions",
      "isInternational",
      "bookingResponse",
      "baggageCost",
      "allFlights",
      "isIframe",
      "invsyUser",
      "passengers",
      "additionalBaggageAllowed"
    ]),
    filteredAirlineCodes() {
      const query = this.activePassengerKey
        ? (
            this.airlineCodeQueryMap[this.activePassengerKey] || ""
          ).toLowerCase()
        : "";
      return this.airlineCodesFlyer.filter(airline => {
        const code = airline.code ? airline.code.toLowerCase() : "";
        const name = airline.name ? airline.name.toLowerCase() : "";
        return code.includes(query) || name.includes(query);
      });
    },
    allChildBags() {
      return this.priceResponse.baggageOptions.allBaggage.filter(
        bag => bag.paxType == "CHD" || bag.paxType == null
      );
    },
    allAdultBags() {
      return this.priceResponse.baggageOptions.allBaggage.filter(
        bag => bag.paxType == "ADT" || bag.paxType == null
      );
    },
    bookingHasIdenticalNames() {
      const passengers = [
        ...this.adults,
        ...this.youngAdults,
        ...this.children,
        ...this.infants
      ];
      // Filter out passengers with undefined or empty first and/or last names
      const validPassengers = passengers.filter(
        x => x.firstName && (x.middleName || x.middleName === "") && x.lastName
      );
      if (validPassengers.length <= 1) return false;

      const fullNames = validPassengers.map(x => {
        // Combine names with proper spacing, including middle name if it exists
        return [x.firstName, x.middleName, x.lastName]
          .filter(Boolean) // Remove undefined/null/empty values
          .join(" ");
      });

      const uniqueNames = new Set(fullNames);
      // If the list of unique names is shorter than the total list of valid passenger names,
      // then a duplicate name is present among the valid entries
      return fullNames.length !== uniqueNames.size;
    },
    formattedMealOptions() {
      return this.mealOptions.map(option => ({
        ...option,
        description: option.description
          .toLowerCase()
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      }));
    },
    countrycodes: function() {
      return CountryCodes;
    },
    airlineCodes() {
      return [{ code: undefined, name: "Select" }, ...AirlineCodes];
    },
    monthList() {
      return [...MonthList];
    },
    lastDateOfTravel() {
      const dates = this.allFlights.map(x => new Date(x.departureDateTime));
      return new Date(Math.max(...dates));
    },
    //code for calculating dob ranges
    adultMin() {
      return new Date(
        this.lastDateOfTravel.getFullYear() - 100,
        this.lastDateOfTravel.getMonth(),
        this.lastDateOfTravel.getDate(),
        this.lastDateOfTravel.getHours()
      );
    },
    adultMax() {
      return new Date(
        this.lastDateOfTravel.getFullYear() - 16,
        this.lastDateOfTravel.getMonth(),
        this.lastDateOfTravel.getDate(),
        this.lastDateOfTravel.getHours()
      );
    },
    youngAdultMin() {
      return new Date(
        this.lastDateOfTravel.getFullYear() - 16,
        this.lastDateOfTravel.getMonth(),
        this.lastDateOfTravel.getDate() + 1, //days one day to avoid overlap
        this.lastDateOfTravel.getHours()
      );
    },
    youngAdultMax() {
      return new Date(
        this.lastDateOfTravel.getFullYear() - 12,
        this.lastDateOfTravel.getMonth(),
        this.lastDateOfTravel.getDate(),
        this.lastDateOfTravel.getHours()
      );
    },
    childMin() {
      return new Date(
        this.lastDateOfTravel.getFullYear() - 12,
        this.lastDateOfTravel.getMonth(),
        this.lastDateOfTravel.getDate() + 1, //days one day to avoid overlap
        this.lastDateOfTravel.getHours()
      );
    },
    childMax() {
      return new Date(
        this.lastDateOfTravel.getFullYear() - 2,
        this.lastDateOfTravel.getMonth(),
        this.lastDateOfTravel.getDate(),
        this.lastDateOfTravel.getHours()
      );
    },
    infantMin() {
      return new Date(
        this.lastDateOfTravel.getFullYear() - 2,
        this.lastDateOfTravel.getMonth(),
        this.lastDateOfTravel.getDate() + 1, //days one day to avoid overlap
        this.lastDateOfTravel.getHours()
      );
    },
    infantMax() {
      return new Date(
        this.lastDateOfTravel.getFullYear(),
        this.lastDateOfTravel.getMonth(),
        this.lastDateOfTravel.getDate(),
        this.lastDateOfTravel.getHours()
      );
    },
    //end of dob range code
    allPassengers() {
      return [
        ...this.adults,
        ...this.youngAdults,
        ...this.children,
        ...this.infants
      ];
    },
    isRadixx() {
      let result = false;
      this.priceResponse.itineraries.forEach(itinerary => {
        itinerary.odoList.forEach(odo => {
          if (odo.companyName === "Radixx") {
            result = true;
          }
        });
      });
      return result;
    },
    isVerteil() {
      let result = false;
      this.priceResponse.itineraries.forEach(itinerary => {
        itinerary.odoList.forEach(odo => {
          if (odo.companyName === "Verteil") {
            result = true;
          }
        });
      });
      return result;
    },
    //Method to check if the selected flight is BA Verteil
    isBAVerteil() {
      let result = false;
      this.priceResponse.itineraries.forEach(itinerary => {
        itinerary.odoList.forEach(odo => {
          if (
            odo.companyName === "Verteil" &&
            odo.validatingCarrierCode === "BA"
          ) {
            result = true;
          }
        });
      });
      return result;
    },
    //Method to the selected flight is not BA Verteil and has young adults
    isYoungAdultException() {
      if (
        !this.isBAVerteil &&
        this.searchParameters.travellers.youngAdults !== 0
      ) {
        console.log("young adult exception required");
        return true;
      } else {
        console.log("young adult exception not required");
        return false;
      }
    },
    blockHeading: function() {
      switch (this.block) {
        case 1:
          return "Who is travelling?";
        case 2:
          return "Who is paying?";
        case 3:
          return "Payment options";
        case 4:
          return "Payment details";
        case 5:
          return "Billing address";
        default:
          return "Details";
      }
    },
    paymentOptionCost() {
      if (this.block < 3) {
        return undefined;
      } else if (
        this.paymentMethod &&
        this.paymentMethod.products &&
        this.paymentMethod.products.length > 1
      ) {
        this.$store.commit(
          "updatePaymentCharge",
          this.paymentMethod.products[0].amount
        );
        return this.paymentMethod.products[0].amount;
      }
      return undefined;
    },
    adultSettings() {
      return this.priceResponse.passengerSettings.adultSettings;
    },
    youngAdultSettings() {
      return this.priceResponse.passengerSettings.youngAdultSettings;
    },
    childSettings() {
      return this.priceResponse.passengerSettings.childSettings;
    },
    infantSettings() {
      return this.priceResponse.passengerSettings.infantSettings;
    },
    isDepartureMoreThan72HoursAway() {
      // Get departure airport timezone and calculate timezone-adjusted time difference in hours
      if (!this.allFlights || this.allFlights.length === 0) return false;

      const firstFlight = this.allFlights[0];
      const departureCode = firstFlight.origCode;
      const departureAirport = this.allAirports.find(
        airport => airport.airportCode === departureCode
      );

      if (!departureAirport) return false;

      const dateString = firstFlight.departureDateTime;
      const [datePart, timePart] = dateString.split("T");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);

      const airportTimezoneOffset = departureAirport.timezone;
      const departureLocalMs = Date.UTC(
        year,
        month - 1,
        day,
        hour,
        minute,
        second || 0
      );
      const departureUTCMs =
        departureLocalMs - airportTimezoneOffset * 60 * 60 * 1000;

      const nowUTCMs = Date.now();
      const diffHours = (departureUTCMs - nowUTCMs) / (1000 * 60 * 60);

      return diffHours >= 72;
    },
    offersMeals() {
      const mealsOffered = this.priceResponse.itineraries[0]
        .specialServiceAttributes
        ? this.priceResponse.itineraries[0].specialServiceAttributes.offerMeals
        : false;
      return mealsOffered && this.isDepartureMoreThan72HoursAway;
    },
    offersFrequentFlyer() {
      return this.priceResponse.itineraries[0].specialServiceAttributes
        ? this.priceResponse.itineraries[0].specialServiceAttributes
            .offerFrequentFlyerMiles
        : false;
    },
    paymentMethodValidationErrors() {
      if (
        !this.isEmpty(
          this.paymentMethodResponse &&
            this.paymentMethodResponse.validationResults
        )
      ) {
        if (!this.paymentMethodResponse.validationResults.isValid) {
          return true;
        }
      }
      return false;
    },
    paymentValidationErrors() {
      let result = [];
      if (!this.isEmpty(this.bookingResponse)) {
        result = Object.keys(
          this.bookingResponse.validationResults.paymentDetailsValidationResults
            .invalidFields
        );
      }
      return result;
    },
    stepBlock: {
      get() {
        return this.block - 1;
      },
      set(newVal) {
        this.setBlock(newVal + 1);
        return newVal;
      }
    },
    totalPurchasedBaggage() {
      let result = 0;
      this.adults
        .concat(this.youngAdults)
        .concat(this.children)
        .concat(this.infants)
        .forEach(e => {
          if (e.baggageSelection) {
            e.baggageSelection.forEach(bag => {
              if (bag.selected === true) {
                result++;
              }
            });
          }
        });
      return result;
    },
    airlineCodesOnBooking() {
      // A map of unique airline codes related to the booking
      return [...new Set(this.allFlights.map(x => x.airlineCode))];
    },
    isEnabledBaggageCarrier() {
      //  Get unique airline codes from booking
      const airlineCodes = this.airlineCodesOnBooking;
      // Check for Radixx booking OR if any airline code from the booking is in the list of enabled carriers
      return (
        this.isRadixx ||
        airlineCodes.some(code => this.baggageEnabledCarriers.includes(code))
      );
    }
  },
  watch: {
    airlineCodeQueryMap: {
      deep: true,
      handler(newMap) {
        if (this.activePassengerKey) {
          const currentQuery = newMap[this.activePassengerKey];
          if (currentQuery === undefined) {
            // Use the display value from the map for the active passenger
            this.$set(
              this.airlineCodeQueryMap,
              this.activePassengerKey,
              this.selectedAirlineDisplayMap[this.activePassengerKey] || ""
            );
          }
        }
      }
    },
    cardDetails: {
      handler(newVal) {
        if (newVal.cardNumber) {
          let v = newVal.cardNumber.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
          let matches = v.match(/\d{4,16}/g);
          let match = (matches && matches[0]) || "";
          let parts = [];
          for (let i = 0; i < match.length; i += 4) {
            parts.push(match.substring(i, i + 4));
          }
          if (parts.length) {
            this.cardDetails.cardNumber = parts.join(" ");
          } else {
            this.cardDetails.cardNumber = newVal.cardNumber;
          }
        }
      },
      deep: true
    },
    billingDetails: {
      handler(newVal) {
      if (!newVal.vatInvoice) {
        newVal.companyName = undefined;
        newVal.companyVatNo = undefined;
      }
      },
      deep: true
    },
    paymentOption: {
      handler(newVal) {
        if (
          newVal.paymentOptionName == "IPAY" ||
          newVal.paymentOptionName == "CASH"
        ) {
          this.paymentMethod = newVal.paymentMethods[0];
        }
      }
    },
    payerSameAsPassenger: {
      handler(newVal) {
        return this.setPayerToPassenger(newVal);
      },
      deep: true
    },
    payer: {
      payer: {
        handler(newVal) {
          if (newVal && newVal.mobileNumber) {
            this.billingDetails.contactNo = String(newVal.mobileNumber).replace(/[^+\d]/g, "");
          } else {
            this.billingDetails.contactNo = "";
          }
          this.billingDetails.contactCode = newVal ? newVal.mobileCode : "";
        },
        deep: true
      }
    },
    totalPurchasedBaggage: {
      handler() {
        let cost = 0;
        this.adults
          .concat(this.youngAdults)
          .concat(this.children)
          .concat(this.infants)
          .forEach(passenger => {
            if (passenger.baggageSelection) {
              passenger.baggageSelection.forEach(bag => {
                if (bag.selected) {
                  let price = this.priceResponse.baggageOptions.allBaggage.find(
                    option => {
                      return option.id == bag.id;
                    }
                  ).amount;
                  cost += price;
                }
              });
            }
          });
        this.$store.commit("updateBaggageCost", cost);
      }
    }
  },
  methods: {
    updateMealProduct() {
      const products = this.$store.state.products.map(product => {
        if (product.id === "MEALS") {
          product.selectedValue = this.allPassengers.some(
            passenger => passenger.specialRequests.mealSelection
          );
        }
        return product;
      });
      this.$store.commit(
        "updateProducts",
        products.filter(p => p.selectedValue).map(p => p.id)
      );
    },
    filterAirlineCodes(query, passengerKey) {
      this.$set(this.airlineCodeQueryMap, passengerKey, query || "");
    },
    selectAirline(option, passenger, passengerKey) {
      this.$set(
        this.selectedAirlineDisplayMap,
        passengerKey,
        `${option.name} (${option.code})`
      );
      this.$set(
        this.airlineCodeQueryMap,
        passengerKey,
        `${option.name} (${option.code})`
      );
      this.$set(
        passenger.specialRequests.frequentFlyerDetailsList[0],
        "airlineCode",
        option.code
      );
    },

    setActivePassenger(key) {
      this.activePassengerKey = key;
      // Sync the query with the current passenger's value
      if (!this.airlineCodeQueryMap[key]) {
        this.$set(this.airlineCodeQueryMap, key, "");
      }
    },

    clearAirlineCodeQuery(passengerKey) {
      this.$set(this.airlineCodeQueryMap, passengerKey, "");
      this.$set(this.selectedAirlineDisplayMap, passengerKey, "");

      if (passengerKey.startsWith("adult-")) {
        const index = parseInt(passengerKey.split("-")[1]);
        this.$set(
          this.adults[index].specialRequests.frequentFlyerDetailsList[0],
          "airlineCode",
          null
        );
      } else if (passengerKey.startsWith("youngAdult-")) {
        const index = parseInt(passengerKey.split("-")[1]);
        this.$set(
          this.youngAdults[index].specialRequests.frequentFlyerDetailsList[0],
          "airlineCode",
          null
        );
      }

      if (this.activePassengerKey === passengerKey) {
        this.activePassengerKey = null;
      }
    },
    invsyLink(url) {
      this.$store.dispatch("invsyLink", url);
    },
    handleNameInput(value, passenger) {
      const nameParts = value.trim().split(/\s+/);
      passenger.firstName = nameParts[0] || "";
      passenger.middleName = nameParts.slice(1).join(" ") || undefined;
    },
    resetCardValidation() {
      console.log("resetting card validation");
      this.cardDetails.errors.cardNumber = false;
    },
    openLoader() {
      this.$store.commit("setLoader", true);
      this.$buefy.modal.open({
        parent: this,
        component: Loader,
        canCancel: [false, false, false]
      });
    },
    openPaymentLoader(message) {
      this.$store.commit("setLoader", true);
      this.$buefy.modal.open({
        parent: this,
        component: PaymentMethodsLoader,
        props: { message },
        canCancel: [false, false, false]
      });
    },
    closeLoader() {
      this.$store.commit("setLoader", false);
    },
    toggleMobileReview() {
      this.mobileReviewModal = !this.mobileReviewModal;
    },
    clearError(val) {
      console.log(val);
      val = undefined;
    },
    setBlock(val) {
      this.block = val;
      this.$store.commit("updateBlock", val);
    },
    async autofill() {
      this.adults
        .concat(this.youngAdults)
        .concat(this.children)
        .concat(this.infants)
        .forEach(e => {
          e.firstName = "test";
          e.lastName = "test";
          e.dateOfBirth = new Date("1990-05-02");
        });
      this.payerSameAsPassenger();
    },
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    redeemDetailsAlert() {
      this.$buefy.dialog.alert({
        title: "How it works",
        message: `
                <ul class="square-list">
                    <li>Pay for your booking in full using your Investec Visa card</li>
                    <li>Select if you would like to redeem Rewards points to reduce the cost of your transaction</li>
                    <li>You can redeem either 50% or 100% of the booking amount</li>
                    <li>If you do not have sufficient points given your selection, the maximum amount in increments of 5 000 points will be redeemed</li>
                    <li>Your travel redemption rebate will reflect as a credit in your Investec Private Bank Account within 48-72 business hours.</li>
                </ul>`,
        confirmText: "Close"
      });
    },
    payerCountryChanged(country) {
      this.payer.mobileCode = country.dialCode;
      this.billingDetails.contactCode = country.dialCode;
    },
    initBooking() {
      if (this.$store.state.isApiDown) {
        return;
      }
      this.openPaymentLoader("Confirming Your Booking...");
      this.validationError = false;
      this.cardDetails.redeemPercentage = this.redeemPercentage;
      this.$store.commit("setPayer", this.payer);
      this.$store.commit("setPassengers", {
        adults: this.adults,
        youngAdults: this.youngAdults,
        children: this.children,
        infants: this.infants,
        isYoungAdultsException: this.isYoungAdultException
      });
      this.book();
    },
    verteilPassengerTitleConversion(requestBody) {
      if (requestBody.contact.title === "Miss") {
        requestBody.contact.title = "Ms";
      }

      Object.keys(requestBody.passengers).forEach(passengerType => {
        if (requestBody.passengers[passengerType]) {
          for (
            let i = 0;
            i < requestBody.passengers[passengerType].length;
            i++
          ) {
            if (requestBody.passengers[passengerType][i].title === "Miss") {
              requestBody.passengers[passengerType][i].title = "Ms";
            }
          }
        }
      });
    },
    createBookBody() {
      let body = {
        data: this.priceResponse.data,
        sessionID: this.$store.state.session,
        paymentData: this.paymentMethodResponse.data,
        paymentReturnURL:
          this.paymentOption.paymentOptionName === "CC_3D" ||
          this.paymentOption.paymentOptionName === "DC_3D"
            ? process.env.VUE_APP_BASE_API_URL + "three-d-redirect"
            : null,
        contact: {
          email: this.payer.email,
          firstName: this.payer.firstName,
          lastName: this.payer.lastName,
          mobileCode: this.payer.mobileCode,
          mobileNo: this.payer.mobileNumber.replace(/[^+\d]/g, ""),
          title: this.payer.title
        },
        ignoreDuplicateBookings: true,
        // passengers from store
        passengers: this.passengers,
        products: this.products,
        selectedPaymentMethod: this.paymentMethod,
        cardDetails: this.cardDetails
          ? this.cleanCardDetails(this.cardDetails)
          : undefined,
        billingDetails: this.paymentMethod.requiresBillingAddress
          ? this.cleanAddress(this.billingDetails)
          : undefined,
        deliveryDetails: this.paymentMethod.requiresBillingAddress
          ? this.cleanAddress(this.billingDetails)
          : undefined,
        baggageSelection: this.baggageSelection
          ? this.baggageSelection
          : undefined,
        voucherProduct: this.voucherProduct ? this.voucherProduct : undefined
      };

      if (this.isVerteil) {
        this.verteilPassengerTitleConversion(body);
      }

      this.$store.commit("saveBookBody", body);
      return body;
    },
    async book() {
      let body = this.createBookBody();
      try {
        const result = await Promise.race([
          Api.book(body),
          // timeout after 1.5 minute
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("Request timeout")), 90000)
          )
        ]);
        this.processBookingResponse(result);
      } catch (error) {
        console.error("Booking API error:", error.message);
        this.closeLoader();
        if (error.message === "Request timeout") {
          this.$buefy.toast.open({
            message: "Booking request timed out. Please try again.",
            type: "is-danger"
          });
        } else {
          this.$router.push("failure");
        }
      }
    },
    async processBookingResponse(result) {
      this.$store.commit("setBookingResponse", result.data);
      if (result.data.errors && result.data.bookingInformation === null) {
        this.handleBookingError();
      } else if (
        result.data.validationResults &&
        !result.data.validationResults.isValid
      ) {
        this.handleValidationResponse(result.data.validationResults);
      } else if (result.data.threeDSecureBookingResponse) {
        this.closeLoader();
        this.$router.push("threeDSecure");
      } else if (result.data.redirectGatewayBookingResponse) {
        this.closeLoader();
        this.$router.push("ipay");
      } else {
        this.closeLoader();
        this.$router.push("confirmation");
      }
    },
    handleBookingError() {
      console.log("book failed with errors");
      this.billingDetails.errors = [];
      this.payer.errors = [];
      this.closeLoader();
      this.$router.push("failure");
    },
    generatePnpTickets() {
      let tickets = [];
      let schedules = [];
      this.allFlights.forEach(flight => {
        schedules.push({
          description: `Flight from ${flight.origCode} to ${flight.destCode}`,
          referenceNumber: "123",
          startDateTime: moment(flight.departureDateTime).format(
            "DD/MM/YYYY HH:mm"
          )
        });
      });
      this.adults
        .concat(this.youngAdults)
        .concat(this.children)
        .concat(this.infants)
        .forEach(passenger => {
          tickets.push({
            person: {
              firstName: passenger.firstName,
              middleName: passenger.middleName,
              lastName: passenger.lastName,
              contactNumber: this.payer.mobileNumber.replace(/[^+\d]/g, "")
            },
            schedules: schedules
          });
        });
      return tickets;
    },
    async paymentMethods() {
      // this.openLoader();
      this.openPaymentLoader("Loading Payment Methods...");
      try {
        const result = await Api.paymentMethods({
          data: this.priceResponse.data,
          sessionID: this.$store.state.session,
          contact: {
            email: this.payer.email,
            firstName: this.payer.firstName,
            lastName: this.payer.lastName,
            mobileCode: this.payer.mobileCode,
            mobileNo: this.payer.mobileNumber.replace(/[^+\d]/g, ""),
            title: this.payer.title
          },
          ignoreDuplicateBookings: true,
          passengers: {
            adults: this.cleanPassengers(this.adults),
            youngAdults: this.cleanPassengers(this.youngAdults),
            children: this.cleanPassengers(this.children),
            infants: this.cleanPassengers(this.infants)
          },
          products: this.products,
          baggageSelection: this.baggageSelection
            ? this.baggageSelection
            : undefined,
          voucherProduct: this.voucherProduct ? this.voucherProduct : undefined
        });
        this.paymentMethodsResults = result.data;
        this.$store.commit("setPaymentMethodResponse", result.data);
        this.paymentMethodsComplete = true;
        if (!result.data.errors) {
          this.paymentOption = result.data.paymentOptions.find(
            option => option.paymentOptionName == "CC"
          );
          this.block = 4;
          // this.block = 3;
          this.$store.commit("updateBlock", this.block);
          this.closeLoader();
        } else {
          this.closeLoader();
          this.$router.push("failure");
        }
      } catch (error) {
        this.closeLoader();
        this.$router.push("failure");
      }
    },
    cleanPassengers(passengers) {
      passengers.forEach(passenger => {
        passenger.errors = undefined;
        // if specialRequests object is empty then remove it from the object
        if (
          passenger.specialRequests &&
          Object.keys(passenger.specialRequests).length === 0
        ) {
          delete passenger.specialRequests;
        } else if (passenger.specialRequests.mealSelection === null) {
          delete passenger.specialRequests.mealSelection;
        }
      });
      return passengers;
    },
    dirtyPassengers(passengers) {
      passengers.forEach(passenger => {
        passenger.errors = [];
      });
      return passengers;
    },
    cleanAddress(address) {
      address.errors = {};
      return address;
    },
    cleanCardDetails(card) {
      // build expiry date from expiryMonth and expiryYear
      card.expirationDate = {
        day: 1,
        month: card.expiryMonth,
        year: card.expiryYear
      };
      card.cardType = undefined;
      return card;
    },
    validateMaxCharLengthOnPassenger(passenger) {
      const maxCharacterLength =
        PASSENGER_NAME_CHAR_LIMIT - STANDARD_NAME_BUFFER;
      this.displayMaxCharLimitAllPax = maxCharacterLength;
      return isPassengerNameWithinCharLimit(passenger);
    },

    validateMaxLengthForInfantBookings(infant, adult) {
      const maxCharacterLengthInfant =
        PASSENGER_NAME_CHAR_LIMIT - INFANT_COMBINED_NAME_BUFFER;
      this.displayMaxCharLimitInfant = maxCharacterLengthInfant;
      return isInfantBookingNameWithinCharLimit(infant, adult);
    },
    setPayerToPassenger: function(isTrue) {
      if (isTrue) {
        this.payer.title = this.adults[0].title;
        // Combine firstName and middleName with a space if middleName exists
        this.payer.firstName = [
          this.adults[0].firstName,
          this.adults[0].middleName
        ]
          .filter(Boolean)
          .join(" ");
        this.payer.lastName = this.adults[0].lastName;
      } else {
        this.payer.title = null;
        this.payer.firstName = null;
        this.payer.lastName = null;
      }
    },
    validateMiddleName: function(name) {
      return validatePassengerMiddleName(name);
    },
    validateName: function(name) {
      return validatePassengerName(name);
    },
    validateBlock1: function() {
      this.errors = [];
      let valid = true;
      if (this.bookingHasIdenticalNames) valid = false;

      // Max character limit check for adults and infants bookings
      // Iterate through all passengers, including adults, children, and infants
      for (let i = 0; i < this.adults.length; i++) {
        const adult = this.adults[i];
        const infant = this.infants[i];

        // If there's an infant at the same index as the adult, validate them
        if (infant) {
          if (!this.validateMaxLengthForInfantBookings(infant, adult)) {
            this.errors.push(
              `Validation failed for infant at index ${i} with corresponding adult.`
            );
            this.maxBookingCharacterLengthError = true;
            return (valid = false);
          }
        }
      }

      for (let passenger of this.adults
        .concat(this.youngAdults)
        .concat(this.children)
        .concat(this.infants)) {
        passenger.errors = [];

        // Validate max character length on each passenger
        if (!this.validateMaxCharLengthOnPassenger(passenger)) {
          this.errors.push(`Passenger character limit exceeded.`);
          passenger.errors.fullNameTooLong = true;
          return (valid = false);
        }

        // if domestic add dummy passport and nationality fields
        if (!this.isInternational) {
          applyDomesticPassportPlaceholders(passenger);
        }
        if (!passenger.title) {
          passenger.errors.title = true;
          valid = false;
        }
        if (!this.validateName(passenger.firstName)) {
          passenger.errors.firstName = true;
          valid = false;
        }
        if (!this.validateMiddleName(passenger.middleName)) {
          passenger.errors.firstName = true;
          valid = false;
        }
        if (!this.validateName(passenger.lastName)) {
          passenger.errors.lastName = true;
          valid = false;
        }
        if (!passenger.passportNumber) {
          passenger.errors.passportNumber = true;
          valid = false;
        }
        // check everything in dob object is valid
        if (
          !passenger.dob.day ||
          !passenger.dob.month ||
          !passenger.dob.year ||
          !moment(
            `${passenger.dob.year}-${passenger.dob.month}-${passenger.dob.day}`,
            "YYYY-MM-DD"
          ).isValid()
        ) {
          passenger.errors.day = true;
          passenger.errors.month = true;
          passenger.errors.year = true;
          passenger.errors.dateOfBirth = true;
          return false;
        }
        // make dateOfBirth from dob object
        passenger.dateOfBirth = moment(
          `${passenger.dob.year}-${passenger.dob.month}-${passenger.dob.day}`,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");
        if (!passenger.dateOfBirth) {
          passenger.errors.dateOfBirth = true;
          valid = false;
        }
        if (this.isInternational && !passenger.tempPassportExpiry) {
          if (
            !passenger.passportExpiry.day ||
            !passenger.passportExpiry.month ||
            !passenger.passportExpiry.year ||
            !moment(
              `${passenger.passportExpiry.year}-${passenger.passportExpiry.month}-${passenger.passportExpiry.day}`,
              "YYYY-MM-DD"
            ).isValid()
          ) {
            passenger.errors.pday = true;
            passenger.errors.pmonth = true;
            passenger.errors.pyear = true;
            passenger.errors.tempPassportExpiry = true;
            return false;
          }
          // make dateOfBirth from dob object
          passenger.tempPassportExpiry = moment(
            `${passenger.passportExpiry.year}-${passenger.passportExpiry.month}-${passenger.passportExpiry.day}`,
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD");
        }
        if (passenger.type === "ADULT") {
          if (new Date(passenger.dateOfBirth) > this.youngAdultMin) {
            passenger.errors.dateOfBirthRange = true;
            valid = false;
          }
        } else if (passenger.type === "YOUNGADULT") {
          let currentDate = new Date(passenger.dateOfBirth);
          if (
            currentDate < this.youngAdultMin ||
            currentDate > this.youngAdultMax
          ) {
            passenger.errors.dateOfBirthRange = true;
            valid = false;
          }
        } else if (passenger.type === "CHILD") {
          let currentDate = new Date(passenger.dateOfBirth);
          if (currentDate < this.childMin || currentDate > this.childMax) {
            passenger.errors.dateOfBirthRange = true;
            valid = false;
          }
        } else if (passenger.type === "INFANT") {
          let currentDate = new Date(passenger.dateOfBirth);
          if (currentDate < this.childMax) {
            passenger.errors.dateOfBirthRange = true;
            valid = false;
          }
        }
      }
      if (!valid) {
        console.log("wasnt valid");
        this.errors.push("One or more fields are incomplete");
        window.scrollTo(0, 0, "smooth");
        return false;
      }
      this.errors = [];
      console.log("got here");
      this.block++;
      this.$store.commit("updateBlock", this.block);
      window.scrollTo(0, 0, "smooth");
    },
    validateBlock2: function() {
      this.errors = [];
      let valid = true;
      this.payer.errors = [];
      if (!this.validateName(this.payer.firstName)) {
        this.payer.errors.firstName = true;
        valid = false;
      }
      if (!this.validateName(this.payer.lastName)) {
        this.payer.errors.lastName = true;
        valid = false;
      }
      if (!this.payer.title) {
        this.payer.errors.title = true;
        valid = false;
      }
      if (
        !this.validMobile(this.payer.mobileNumber)
      ) {
        this.payer.errors.isValidMobileNumber = true;
        valid = false;
      } else {
        this.payer.errors.isValidMobileNumber = false;
        this.billingDetails.contactNo = this.payer.mobileNumber.replace(/[^+\d]/g, "");
      }
      if (!this.payer.email) {
        this.payer.errors.email = true;
        valid = false;
      } else if (!this.validEmail(this.payer.email)) {
        this.payer.errors.isValidEmail = true;
        valid = false;
      }
      if (!valid) {
        this.errors.push("One or more fields are incomplete");
        window.scrollTo(0, 0, "smooth");
        return false;
      }
      this.errors = [];
      this.paymentMethods();
      window.scrollTo(0, 0, "smooth");
    },
    validateBlock3: function() {
      this.errors = [];
      let valid = true;
      if (
        this.paymentOption.paymentOptionName === "CC" ||
        this.paymentOption.paymentOptionName === "CC_3D" ||
        this.paymentOption.paymentOptionName === "DC_3D" ||
        this.paymentOption.paymentOptionName === "EFT"
      ) {
        this.block++;
        this.$store.commit("updateBlock", this.block);
      } else if (
        this.paymentOption.paymentOptionName === "IPAY" ||
        this.paymentOption.paymentOptionName === "CASH"
      ) {
        this.block = 5;
        this.$store.commit("updateBlock", this.block);
      } else {
        this.valid = false;
      }
      if (!valid) {
        this.errors.push("One or more fields are incomplete");
        window.scrollTo(0, 0, "smooth");
        return false;
      }
      window.scrollTo(0, 0, "smooth");
    },
    validateBlock4: function() {
      // Reset all errors
      this.errors = [];
      this.cardDetails.errors = {};
      this.billingDetails.errors = {};
      this.termsError = false;
      this.airRulesError = false;
      let isValid = true;

      // Helper function for scrolling to elements
      const scrollToElement = id => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ 
            behavior: "smooth",
            block: "center",
            inline: "nearest"
          });
        }
      };



      // Credit Card Validation
      if (
        this.paymentOption.paymentOptionName === "CC" ||
        this.paymentOption.paymentOptionName === "CC_3D" ||
        this.paymentOption.paymentOptionName === "DC_3D"
      ) {
        // Validate card details
        if (!this.cardDetails.cardNumber) {
          this.errors.push("Card Number is required");
          this.cardDetails.errors.cardNumber = true;
          isValid = false;
        }
        if (!this.cardDetails.nameOnCard) {
          this.errors.push("Card Holder Name is required");
          this.cardDetails.errors.nameOnCard = true;
          isValid = false;
        }
        if (!this.cardDetails.expiryMonth) {
          this.errors.push("Expiry Month is required");
          this.cardDetails.errors.expiryMonth = true;
          isValid = false;
        }
        if (!this.cardDetails.expiryYear) {
          this.errors.push("Expiry Year is required");
          this.cardDetails.errors.expiryYear = true;
          isValid = false;
        }
        if (this.cardDetails.expiryMonth && this.cardDetails.expiryYear) {
          let expiryDate = new Date(
            this.cardDetails.expiryYear,
            this.cardDetails.expiryMonth,
            0
          );
          let today = new Date();
          if (expiryDate < today) {
            this.errors.push("Card has expired");
            this.cardDetails.errors.expiryDate = true;
            isValid = false;
          }
        }
        if (!this.cardDetails.cvv) {
          this.errors.push("CVV is required");
          this.cardDetails.errors.cvv = true;
          isValid = false;
        }
        if (!isValid) {
          scrollToElement("cardPaymentWrapper");
          return false;
        }
        this.paymentMethod = this.paymentOption.paymentMethods.find(
          e => e.paymentMethodName == "VC"
        );
      } else if (this.isEmpty(this.paymentMethod)) {
        this.errors.push("Invalid or undefined payment method.");
        scrollToElement("cardPaymentWrapper");
        return false;
      }

      // Credit card number validation
      if (!this.validCreditCard(this.cardDetails.cardNumber)) {
        this.cardDetails.errors.cardNumber = true;
        this.errors.push("Invalid card number");
        scrollToElement("cardPaymentWrapper");
        return false;
      }

      // Billing Details Validation
      if (this.paymentMethod  && this.paymentMethod.requiresBillingAddress) {
        if (!this.billingDetails.addressLine1) {
          this.billingDetails.errors.addressLine1 = true;
          scrollToElement("billingDetails");
          isValid = false;
        }
        if (!this.billingDetails.addressLine2) {
          this.billingDetails.addressLine2 = undefined;
        }
        if (!this.billingDetails.postalCode) {
          this.billingDetails.errors.postalCode = true;
          scrollToElement("billingDetails");
          isValid = false;
        }
        if (!this.billingDetails.city) {
          this.billingDetails.errors.city = true;
          scrollToElement("billingDetails");
          isValid = false;
        }
        if (!this.billingDetails.country) {
          this.billingDetails.errors.country = true;
          scrollToElement("billingDetails");
          isValid = false;
        }
        if (!this.billingDetails.contactNo) {
          this.billingDetails.errors.contactNo = true;
          scrollToElement("billingDetails");
          isValid = false;
        } else if (
          !this.validMobile(this.billingDetails.contactNo.replace(/\s+/g, ""))
        ) {
          this.billingDetails.errors.isValidContactNo = true;
          scrollToElement("billingDetails");
          isValid = false;
        }
        // VAT Invoice Validation
        if (
          this.billingDetails.vatInvoice &&
          !this.billingDetails.companyName
        ) {
          this.billingDetails.errors.companyName = true;
          scrollToElement("companyName");
          isValid = false;
        }
        //not mandatory for users by passing dummy value
        if (
          this.billingDetails.vatInvoice &&
          (!this.billingDetails.companyVatNo || !this.billingDetails.companyVatNo.trim())
        ) {
          this.billingDetails.companyVatNo = "Not applicable"; 
        }
      }

      // Terms and Conditions Validation
      if (!this.termsAgreed) {
        this.errors.push("Please accept terms and conditions.");
        scrollToElement("termsAndConditions");
        this.termsError = true;
        isValid = false;
      }
      if (!this.airRulesCheck) {
        this.errors.push("Please accept airline rules.");
        scrollToElement("termsAndConditions");
        this.airRulesError = true;
        isValid = false;
      }

      // Final validation check
      if (!isValid) {
        this.errors.push("One or more fields are incorrect.");
        return false;
      }

      // All validations passed
      this.errors = [];
      this.initBooking();
      window.scrollTo(0, 0, "smooth");
    },

    back: async function(block = null) {
      this.errors = [];
      // if (this.block == 2) {
      //   await this.initPassengers();
      // }
      if (block == 4) {
        this.dirtyPassengers(this.adults),
          this.dirtyPassengers(this.youngAdults),
          this.dirtyPassengers(this.children),
          this.dirtyPassengers(this.infants);
        this.block = 2;
        this.$store.commit("updateBlock", this.block);
      } else {
        this.block--;
        this.$store.commit("updateBlock", this.block);
      }
      window.scrollTo(0, 0, "smooth");
    },
    backPage: function() {
      this.errors = [];
      this.$store.commit("resetSelectedFlights");
      this.$router.go(-1);
    },
    validEmail: function(email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validMobile(mobileNumber) {
      if (!mobileNumber) {
        return false;
      }

      let re = /^(\+\d{1,3}[- ]?)?\d{10}$/;
      // let re = /^(?:(?:00)?44|0)7(?:[45789]\d{2}|624)\d{6}$/;
      return re.test(mobileNumber) || /^[0-9]{11,}$/.test(mobileNumber);
      // Remove spaces, dashes, and other formatting characters except "+"
      /**
       * TODO:
       * 
       * Re-add this code when the flag option for mobile numbers is re-added.
       * 
       * const cleanedNumber = mobileNumber.replace(/[^+\d]/g, "");
       * const regex = /^\+?[1-9]\d{9,14}$/;
       * return regex.test(cleanedNumber);
      const cleanedNumber = number.replace(/[^+\d]/g, "");
      const regex = /^\+?[0-9]\d{9,14}$/;
      return regex.test(cleanedNumber);
      */
    },
    validYear: function(year) {
      let re = /^(19|20)\d{2}$/;
      return re.test(year);
    },
    validMonth: function(month) {
      let re = /^(0[1-9]|1[012])$/;
      return re.test(month);
    },
    validCreditCard: function(cardNumber) {
      let card = cardNumber.replace(/\s/g, "");

      let sliced = card.slice(0, 6);
      let premium = card.slice(0, 4);
      if (
        sliced === "402167" ||
        sliced === "417359" ||
        sliced === "422254" ||
        sliced === "426516" ||
        premium === "4060" ||
        premium === "3921" ||
        premium === "4069"
      ) {
        let re = /^((4\d{3})|(5[1-5]\d{2})|(6011))-?\d{4}-?\d{4}-?\d{4}|3[4,7]\d{13}$/;
        return re.test(card);
      }
      return false;
    },
    dobFromInvsy(dateOfBirth) {
      let formatedDateOfBirth = moment(dateOfBirth).format("YYYY-MM-DD");
      let dob = dayjs(formatedDateOfBirth);
      let isDobValid = dayjs(dob, "DD/MMM/YYYY").isValid();

      if (!isDobValid) {
        console.log("Invalid date of birth format:", dob);
        return undefined;
      } else {
        let newDate = new Date(dob);
        let day = newDate.getDate(); // day of the month (from 1 to 31)
        let month = newDate.getMonth() + 1; // month (from 1 to 12, note getMonth() returns from 0 to 11, hence the '+1')
        let year = newDate.getFullYear(); // four digit year
        return { day: day, month: month, year: year };
      }
    },
    initPassengers() {
      this.adults.length = 0;
      this.youngAdults.length = 0;
      this.children.length = 0;
      this.infants.length = 0;
      let baggageSelection =
        this.priceResponse.baggageOptions.allBaggage.length > 0
          ? []
          : undefined;
      this.priceResponse.baggageOptions.allBaggage.forEach(bag => {
        baggageSelection.push({
          id: bag.id,
          selected: false
        });
      });
      // Ensures each pasenger has their own special request object
      const initSpecialRequests = () => ({
        mealSelection: null,
        frequentFlyerDetailsList: [
          { frequentFlyerCode: null, airlineCode: null }
        ]
      });

      let invsyDob = this.isIframe
        ? this.dobFromInvsy(this.invsyUser.DateOfBirth)
        : undefined;

      for (let i = 0; i < this.searchParameters.travellers.adults; i++) {
        this.adults.push({
          dob: {
            day: i == 0 && this.isIframe ? invsyDob.day : undefined,
            month: i == 0 && this.isIframe ? invsyDob.month : undefined,
            year: i == 0 && this.isIframe ? invsyDob.year : undefined
          },
          passportExpiry: {
            day: this.isInternational ? null : undefined,
            month: this.isInternational ? null : undefined,
            year: this.isInternational ? null : undefined
          },
          dateOfBirth:
            i == 0 && this.isIframe
              ? moment(
                  `${invsyDob.year}-${invsyDob.month}-${invsyDob.day}`,
                  "YYYY-MM-DD"
                ).format("YYYY-MM-DD")
              : undefined,
          firstName:
            i == 0 && this.isIframe ? this.invsyUser.FirstName : undefined,
          middleName:
            i == 0 && this.isIframe ? this.invsyUser.MiddleName : undefined,
          lastName:
            i == 0 && this.isIframe ? this.invsyUser.LastName : undefined,
          email:
            i == 0 && this.isIframe ? this.invsyUser.EmailAddress : undefined,
          documentType: undefined,
          documentNumber: undefined,
          passportNumber: undefined,
          passportCountry: undefined,
          TempPassportExpiry: undefined, //dob obj
          nationality: undefined,
          baggageSelection: cloneDeep(baggageSelection),
          baseFare: undefined,
          specialRequests: initSpecialRequests(),
          title: undefined,
          type: "ADULT",
          errors: []
        });
      }
      for (let i = 0; i < this.searchParameters.travellers.youngAdults; i++) {
        this.youngAdults.push({
          dob: {
            day: undefined,
            month: undefined,
            year: undefined
          },
          passportExpiry: {
            day: this.isInternational ? null : undefined,
            month: this.isInternational ? null : undefined,
            year: this.isInternational ? null : undefined
          },
          firstName: undefined,
          middleName: undefined,
          lastName: undefined,
          email: undefined,
          documentType: undefined,
          documentNumber: undefined,
          passportNumber: undefined,
          passportCountry: undefined,
          TempPassportExpiry: undefined, //dob obj
          nationality: undefined,
          baggageSelection: cloneDeep(baggageSelection),
          baseFare: undefined,
          specialRequests: initSpecialRequests(),
          title: undefined,
          type: "YOUNGADULT",
          errors: []
        });
      }
      for (let i = 0; i < this.searchParameters.travellers.children; i++) {
        this.children.push({
          dob: {
            day: undefined,
            month: undefined,
            year: undefined
          },
          passportExpiry: {
            day: this.isInternational ? null : undefined,
            month: this.isInternational ? null : undefined,
            year: this.isInternational ? null : undefined
          },
          firstName: undefined,
          middleName: undefined,
          lastName: undefined,
          email: undefined,
          documentType: undefined,
          documentNumber: undefined,
          passportNumber: undefined,
          passportCountry: undefined,
          TempPassportExpiry: undefined, //dob obj
          nationality: undefined,
          baggageSelection: cloneDeep(baggageSelection),
          baseFare: undefined,
          specialRequests: initSpecialRequests(),
          title: undefined,
          type: "CHILD",
          errors: []
        });
      }
      for (let i = 0; i < this.searchParameters.travellers.infants; i++) {
        this.infants.push({
          dob: {
            day: undefined,
            month: undefined,
            year: undefined
          },
          passportExpiry: {
            day: this.isInternational ? null : undefined,
            month: this.isInternational ? null : undefined,
            year: this.isInternational ? null : undefined
          },
          firstName: undefined,
          middleName: undefined,
          lastName: undefined,
          email: undefined,
          documentType: undefined,
          documentNumber: undefined,
          passportNumber: undefined,
          passportCountry: undefined,
          TempPassportExpiry: undefined, //dob obj
          nationality: undefined,
          baggageSelection: cloneDeep(baggageSelection),
          baseFare: undefined,
          specialRequests: initSpecialRequests(),
          title: undefined,
          type: "INFANT",
          errors: []
        });
      }
      this.payer.title = null;
      this.payer.email = this.isIframe ? this.invsyUser.EmailAddress : null;
      this.payer.firstName = this.isIframe ? this.invsyUser.FirstName : null;
      this.payer.lastName = this.isIframe ? this.invsyUser.LastName : null;
      this.payer.mobileNumber = this.isIframe
        ? this.invsyUser.MobileNumber
        : null;
      Promise.resolve();
    },
    handleValidationResponse(response) {
      console.log("book failed with vailidation error");
      this.billingDetails.errors = [];
      this.payer.errors = [];
      this.validationError = true;
      const { paymentDetailsValidationResults: cardValidation } = response;
      if (!cardValidation.isValid) {
        const { invalidFields } = cardValidation;
        if (invalidFields.cardNumberValid !== undefined) {
          this.cardDetails.errors.cardNumber = true;
        }
      }
      this.block = 4;
      this.$store.commit("updateBlock", this.block);
      this.closeLoader();
    },

    //adults dob ranges
    adultDayRange(passenger) {
      return this.dayRange([passenger], "ADULT", this.adultMin, this.adultMax);
    },
    adultMonthRange(passenger) {
      return this.monthRange(
        [passenger],
        "ADULT",
        this.adultMin,
        this.adultMax
      );
    },
    adultYearRange(passenger) {
      return this.yearRange([passenger], "ADULT", this.adultMin, this.adultMax);
    },
    //young adults dob ranges
    youngAdultDayRange(passenger) {
      return this.dayRange(
        [passenger],
        "YOUNGADULT",
        this.youngAdultMin,
        this.youngAdultMax
      );
    },
    youngAdultMonthRange(passenger) {
      return this.monthRange(
        [passenger],
        "YOUNGADULT",
        this.youngAdultMin,
        this.youngAdultMax
      );
    },
    youngAdultYearRange(passenger) {
      return this.yearRange(
        [passenger],
        "YOUNGADULT",
        this.youngAdultMin,
        this.youngAdultMax
      );
    },
    //children dob ranges
    childDayRange(passenger) {
      return this.dayRange(
        [passenger],
        "CHILD",
        this.childMin,
        this.childMax
      );
    },
    childMonthRange(passenger) {
      return this.monthRange(
        [passenger],
        "CHILD",
        this.childMin,
        this.childMax
      );
    },
    childYearRange(passenger) {
      return this.yearRange(
        [passenger],
        "CHILD",
        this.childMin,
        this.childMax
      );
    },
    //infants dob ranges
    infantDayRange(passenger) {
      return this.dayRange(
        [passenger],
        "INFANT",
        this.infantMin,
        this.infantMax
      );
    },
    infantMonthRange(passenger) {
      return this.monthRange(
        [passenger],
        "INFANT",
        this.infantMin,
        this.infantMax
      );
    },
    infantYearRange(passenger) {
      return this.yearRange(
        [passenger],
        "INFANT",
        this.infantMin,
        this.infantMax
      );
    },

    //day range with month and year checks
    dayRange(passengers, type, minAge, maxAge) {
      for (let passenger of passengers) {
        let selectedDob = passenger.dob;
        if (
          passenger.type === type &&
          selectedDob.year != null &&
          selectedDob.month !== null
        ) {
          if (
            selectedDob.year === minAge.getFullYear() &&
            selectedDob.month === minAge.getMonth() + 1 //add one to account for the extra month 0 in the monthList
          ) {
            return this.days.slice(minAge.getDate() - 1);
          } else if (
            selectedDob.year === maxAge.getFullYear() &&
            selectedDob.month === maxAge.getMonth() + 1 //add one to account for the extra month 0 in the monthList
          ) {
            return this.days.slice(0, maxAge.getDate());
          } else {
            return this.days;
          }
        }
      }
      return this.days;
    },
    //month range with year checks
    monthRange(passengers, type, minAge, maxAge) {
      for (let passenger of passengers) {
        let selectedDob = passenger.dob;
        if (passenger.type === type && selectedDob.year != null) {
          if (selectedDob.year === minAge.getFullYear()) {
            return this.monthList.slice(minAge.getMonth() + 1); //add one to account for the extra month 0 in the monthList
          } else if (selectedDob.year === maxAge.getFullYear()) {
            return this.monthList.slice(0, maxAge.getMonth() + 2);
          } else {
            return this.monthList;
          }
        }
      }
      return this.monthList;
    },
    //year range from max and min age
    yearRange(passengers, type, minAge, maxAge) {
      const defaultYearRange = [
        ...Array(maxAge.getFullYear() - minAge.getFullYear() + 1).keys()
      ].map(e => e + minAge.getFullYear());

      for (let passenger of passengers) {
        let selectedDob = passenger.dob;
        if (
          passenger.type === type &&
          selectedDob.month != null &&
          selectedDob.day != null
        ) {
          if (
            selectedDob.month < minAge.getMonth() + 1 ||
            (selectedDob.month === minAge.getMonth() + 1 &&
              selectedDob.day < minAge.getDate())
          ) {
            return defaultYearRange.slice(1, defaultYearRange.length);
          } else if (
            selectedDob.month > maxAge.getMonth() + 1 ||
            (selectedDob.month === maxAge.getMonth() + 1 &&
              selectedDob.day > maxAge.getDate())
          ) {
            return defaultYearRange.slice(0, defaultYearRange.length - 1);
          }
        }
      }
      return defaultYearRange;
    }
  },
  mounted() {
    this.initPassengers();
    this.$store.commit("updateBlock", 1);
  },
  /* eslint-disable vue/no-unused-components */
  components: {
    VueTelInput,
    CreditCardForm,
    TripReview,
    Loader,
    PaymentMethodsLoader,
    SearchEngine,
    CustomDetailsDatepicker,
    CustomDetailsSelect,
    CustomDetailsInput
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.field.has-addons {
  display: block !important;
}

@media (max-width: 781px) {
  .multiline-fix {
    margin-bottom: 0.75em !important;
    * {
      margin-right: 0 !important;
      width: 100% !important;
    }
    flex-wrap: wrap;
  }

  .day-and-month-of-birth {
    display: flex;
    flex-direction: column;
    gap: 16px;

    div.custom-select,
    div.custom-input {
      flex: 1; // This will let both children flex equally
      min-width: 0; // This is to prevent any overflowing content from expanding the box
      width: 100%;
    }

    div.custom-select div.selected-option {
      width: 100%; // Let's use auto for now. Adjust as necessary.
    }

    div.custom-select.max-w-180,
    .max-w-180 {
      max-width: 100%;
    }
  }

  .max-w-120,
  .max-w-180 {
    max-width: none;
  }

  .block-navigation.back {
    background: none !important;
  }
}

.search-blurb-wrapper {
  display: flex;
  align-items: center;
  border-left: 4px solid $brandOranges;
  margin-top: 0;
  margin-bottom: 16px;

  small {
    padding-left: 16px;
    padding-right: 16px;
    color: #30384a;
    font-weight: 400;
  }

  small,
  small a {
    font-size: 12px;
    line-height: 20px;
    font-family: "Inter", sans-serif;
  }
  small a {
    color: $brandOranges;
    font-weight: 600;
  }
}

.max-w-120 {
  max-width: 120px;
}

.max-w-180 {
  max-width: 180px;
}

.py-75 {
  padding-top: 0.75em;
  padding-bottom: 0.75em;
}

.margin-bottom-standard {
  margin-bottom: 0.75em;
}

.underlined {
  text-decoration: underline;
}

.steps {
  grid-area: steps;
  align-self: start;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column-reverse;
  background: none !important;
}

.passenger-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  margin-top: 0rem;
}

.width-100 {
  width: 100%;
}

.no-borders {
  border: none;
}

.how-it-works {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.01em;
  text-decoration-line: underline;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
  cursor: pointer;
}

.margin-bottom-small {
  margin-bottom: 0.75em !important;
}

.block-2,
.block-3,
.block-4 {
  max-width: 600px;
}

.desktop-card-field-wrapper {
  display: flex;
}
.mobile-card-field-wrapper {
  display: none;
}

.margin-bottom {
  margin-bottom: 1.5em !important;
}

.bag-input {
  margin-bottom: 0.5em;
  margin-top: 0.5em;
  font-size: 12px;
}

.payment-option-charge {
  font-size: 12px;
  margin-top: 1em;
  color: #23d160;
  font-weight: bold;
}

.padding-bottom {
  padding-bottom: 0.75em;
}

.is-danger {
  color: #ff3860 !important;
}

.pushed-right {
  margin-left: auto;
}

.redeem-notice {
  font-size: 0.8em;
  color: darken($grey, 30%);
  margin-bottom: 0.75em;
}

.margin-bottom {
  margin-bottom: 0.5em;
}

.passenger-block {
  margin-bottom: 1.25em;
  margin-top: 0;
  padding: 16px;
  max-width: inherit;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.no-wrap {
  white-space: nowrap;
}

.modal-close {
  padding: 0.2em;
  display: flex;
  justify-content: flex-end;
}

.mobile-review-modal {
  z-index: 110;
}

.dev-only {
  padding: 0.4em;
  margin: 15px 0;
  width: fit-content !important;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid black;
  background: lightcoral;
  border-radius: 6px;
  color: white;
}

.rotate-in-enter-active {
  animation: slide-in-left-less 0.15s cubic-bezier(1, 0.5, 0.8, 1) both;
}

.passenger-type {
  width: fit-content;
  margin-bottom: 1em;
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  color: #02214d;
}

#details-page {
  border-radius: 8px;
  max-width: 88%;
}

#trip-review {
  z-index: 10;
}

.search-overview {
  font-size: 0.8em;
}

.container-div {
  display: flex;
  width: 100%; //fix passenger field center issue
  margin: 0 0.5em;
}

form {
  width: 100%;
}

form,
#details-page {
  margin: 0 auto 1em auto;
  margin-bottom: 0.67em;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: -webkit-fill-available;
  z-index: 10;
  .booking-button {
    padding: 0.4em;
    border: 1px solid $primary-dark;
    background: $primary-color;
    border-radius: 6px;
    cursor: pointer;
    color: white;
    .booking-prompt {
      color: white !important;
    }
  }
}
.block-navigation-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  margin-right: 30px;
}
.block-navigation {
  background: $light;
  div {
    width: auto;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  span {
    color: darken($primary-dark, 30%);
  }
  span + i {
    margin-left: 0.5em;
  }
  i + span {
    margin-left: 0.5em;
  }
}
.block-navigation.next {
  border: 2px solid #30384a !important;
  background-color: #30384a !important;
  color: #fff;
  border-radius: 104px;
}

.is-error {
  box-shadow: 0px 0px 0px 1px red !important;
}

.error-message {
  color: red !important;
  font-size: smaller;
}

.is-errorr:after {
  width: 100%;
  height: 100%;
  border: 5px solid red;
}

.payment-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block-heading {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  display: flex;
  align-items: center;
  letter-spacing: 0.2em;
  text-transform: uppercase;

  /* color/ref/navy/900 */

  color: #30384a;
}

.block-heading-2 {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  color: #000000;
}

.mobile-toolbar {
  width: 100%;
  margin-bottom: 1em;
  background: white;
  padding: 0.75em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid lightgray;
}

.block-navigation-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.main-content {
  margin: 0;
}

.redeem-heading {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: #30384a;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.redeem-description {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  display: flex;
  align-items: flex-end;
  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
}

.how-it-works-modal {
  max-width: 824px;
  margin: auto;
  color: $brandBlue !important;
  font-family: "Inter", sans-serif;
  color: #30384a;
  font-size: 16px;
  //margin: 0.75rem;
  padding: 40px;
  background: #ffffff;
  box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.05),
    0px 2px 8px -2px rgba(0, 0, 0, 0.1);
  border-radius: 12px;

  .modal-close-button {
    background: none;
    border: none;
    height: 32px;
    max-height: 32px;
    max-width: 32px;
    min-height: 32px;
    min-width: 32px;
    width: 32px;
  }

  .modal-close-button::before,
  .modal-close-button::after {
    height: 14px;
    width: 1.5px;
    background-color: hsl(0, 0%, 29%) !important;
    color: #30384a;
    content: "";
    display: block;
    position: absolute;
    right: 5%;
    top: 10%;
  }
  .modal-close-button::before {
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    transform-origin: center center;
  }

  .modal-close-button::after {
    transform: translateX(-50%) translateY(-50%) rotate(135deg);
    transform-origin: center center;
  }
  .card-content {
    color: #5b626f;
    ul {
      list-style-type: disc;
      padding-top: 16px;
      padding-bottom: 32px;
      li {
        font-family: "Inter", sans-serif;
        font-size: 16px;
        line-height: 24px;
      }
    }
    .modal-divider {
      height: 2px;
      width: 100%;
      background: #ecece9;
      margin-top: 16px;
      margin-bottom: 32px;
    }
    .modal-close-container {
      display: flex;
      justify-content: flex-end;

      .close-button {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: "Inter", sans-serif;
        width: 54px;
        height: 40px;
        border: 2px solid #30384a !important;
        background-color: #30384a !important;
        color: #fff;
        border-radius: 104px;
        cursor: pointer;
      }
    }
  }
}

.price-heading {
  font-family: "Libre Caslon Text", serif;
  font-size: 40px;
  line-height: 48px;
  font-weight: 400;
  color: #30384a;
}

.redeem-divider {
  height: 2px;
  width: 100%;
  background: #30384a;
}
.flex-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
}

.next {
  width: 200px;
  height: 44px;
  background-color: #485dc5;
  color: white;
  div {
    span {
      color: white;
    }
  }
}

.mt-24 {
  margin-top: 24px;
}

.back {
  margin-right: 3em;
  div {
    display: flex;
    align-items: center;
    span {
      color: $brandBlue;
      margin-left: 1rem;
    }
  }
}

.custom-b-message {
  border-left: 4px solid $brandOranges;
  border-radius: 4px;
  color: #30384a !important;
  background-color: #f6f6f4 !important;
  padding: 20px;
  margin-top: 16px;
  margin-bottom: 16px;

  p {
    margin-top: 12px;
    margin-bottom: 12px;
  }
}

.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding-left: 35px;
  position: relative;
}

.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #ffffff;
  border-radius: 50%;
  border: 2px solid #97989a;
}

.custom-checkbox input:checked ~ .checkmark {
  background-color: #ffffff;
  border: 2px solid #30384a;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.custom-checkbox .checkmark:after {
  left: 50%;
  top: 50%;
  transform: translate(
    -50%,
    -50%
  ); // Shift it back by half of its own width and height
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #30384a;
}
.custom-checkbox:hover .checkmark {
  border-color: black;
}
.custom-checkbox small {
  line-height: 22px;
  margin-top: -16px;
}

//custom checkbox for invoice
.custom-checkbox-2 {
  cursor: pointer;
  user-select: none;
  padding-left: 35px;
  position: relative;
}

.custom-checkbox-2 input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark-2 {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #ffffff;
  border-radius: 50%;
  border: 2px solid #97989a;
}

.custom-checkbox-2 input:checked ~ .checkmark {
  background-color: #ffffff;
  border: 2px solid #30384a;
}


.custom-checkbox-2 input:checked ~ .checkmark:after {
  display: block;
}

.custom-checkbox-2 .checkmark:after {
  left: 50%;
  top: 50%;
  transform: translate(
    -50%,
    -50%
  ); // Shift it back by half of its own width and height
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #30384a;
}
.custom-checkbox-2:hover .checkmark {
  border-color: black;
}
.custom-checkbox-2 small {
  line-height: 22px;
  margin-top: -16px;
}

@media (min-width: 781px) {
  .max-w-49 {
    max-width: 49% !important;
  }

  .trip-reivew {
    margin: 0;
    grid-area: review;
    align-self: start;
  }

  .container-div {
    width: 100%;
  }

  .container-div:nth-child(3) {
    margin-right: auto;
  }

  .main-content {
    grid-area: main;
    margin: 0;
    display: grid;
    align-self: start;
    grid-template-areas:
      "steps steps steps"
      "form form form";
  }

  #details-page {
    background: none;
    border: none;
    box-shadow: none;
    margin: 2em auto;
    display: grid;
    padding-top: 0;
    min-width: 860px;
    max-width: 1100px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-column-gap: 2rem;
    grid-template-areas: "main main review";
  }

  .block-navigation-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    * + * {
      margin-left: 0.75em;
    }
  }
  .next {
    width: 200px;
    height: 44px;
    background-color: #485dc5;
    color: white;
    div {
      span {
        color: white;
      }
    }
  }

  .visa-logo {
    margin-top: 24px;
    margin-bottom: 24px;
    img {
      width: 80px;
      margin-top: 0.75em;
      margin-bottom: 0.75em;
    }
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 0.8em;
    gap: 0.5em;
  }

  .back {
    div {
      display: flex;
      align-items: center;
      span {
        color: $brandBlue;
        margin-left: 1rem;
      }
    }
  }
  .half-field {
    width: 50%;
  }
  .total-block {
    display: block;
    position: absolute;
    right: 20px;
    top: 200px;
    padding: 0.5em 1em;
    background: #2d444d;
    border-radius: 8px;
    border: 1px solid blue;
    color: white;
  }
  .multiline-fix {
    flex-wrap: nowrap !important;
  }
  .is-column {
    flex-direction: column;
  }
  form {
    min-width: 400px;
    max-width: 750px;
    grid-area: form;
    background: #ffffff;
    -webkit-box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.05),
      0px 2px 8px -2px rgba(0, 0, 0, 0.1);
    box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.05),
      0px 2px 8px -2px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    margin-top: 0;
    padding: 32px;
    align-items: flex-start;
    gap: 24px;
  }

  .passenger-block {
    width: 100%;
    background: white;
    padding: 0;
  }

  .form-errors {
    align-self: flex-start;
    width: 100%;
    grid-area: review;
    background: $light;
    padding: $standard-padding;
    max-width: -webkit-fill-available;
  }
}
</style>

<style lang="scss">
.control-label {
  width: 100%;
  align-items: center;
  display: flex;
  img {
    height: 30px;
  }
}

.modal-close {
  background: white !important;
  right: 5px !important;
  top: 5px !important;
}

.control .help.counter {
  display: none !important;
}

.control .help.counter {
  display: none !important;
}

.datepicker {
  min-width: 150px;
}

.select.is-fullwidth select {
  background-color: #fff !important;
}

.step-content {
  padding: 0 !important;
}

.select select,
.textarea,
.input,
.taginput .taginput-container.is-focusable {
  border-radius: 2px !important;
}

.label {
  opacity: 0.8 !important;
  font-size: 14px !important;
}

.square-list {
  list-style-type: square !important;
}

.b-steps .steps .step-items .step-item.is-primary.is-active .step-marker {
  border-color: #be7d2d;
}
.b-steps
  .steps
  .step-items
  .step-item.is-primary.is-active
  .step-marker
  .icon
  * {
  color: #be7d2d;
}

@media (max-width: 781px) {
  .label {
    font-size: 10px !important;
  }
  .main-content {
    margin: 1em !important;
  }
  .desktop-card-field-wrapper {
    display: none !important;
  }
  .block-4 {
    max-width: 100% !important;
  }

  .passenger-block.no-borders {
    padding-left: 32px;
    padding-right: 32px;
  }

  .mobile-card-field-wrapper {
    display: flex !important;
    flex-direction: column;
  }

  .mobile-card-field-wrapper div {
    margin-bottom: 16px;
  }

  .mobile-card-field-wrapper div:last-of-type {
    margin-bottom: 0;
  }
  .visa-logo img {
    width: 75px;
  }

  .airline-details {
    flex-wrap: wrap;
  }

  .airline-picker ::v-deep div .input {
    padding-right: 24px !important;
  }

  .autocomplete .dropdown-item {
    white-space: normal !important;
  }

  .media {
    align-items: center !important;
  }
}

@media (min-width: 781px) {
  .limit-select {
    max-height: 250px !important;
  }

  .flex-row {
    flex-wrap: nowrap;
    gap: 24px;
  }
}

.gap-25 {
  gap: 25px;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  //fix for special request airline code text overflow
  @media (max-width: 781px) {
    flex-wrap: wrap;
  }
}

.block-divider {
  height: 2px;
  width: 100%;
  background: #ecece9;
  margin-top: 16px;
}

.padded-content {
  margin-top: 24px;
  margin-bottom: 24px;
}

.airline-details {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}

.expanded-field {
  width: 100%;
}

.autocomplete-wrapper {
  position: relative;
}

// Airport picker input
.airline-picker ::v-deep div .input {
  height: 64px !important;
  border: none !important;
  box-shadow: none !important;
  background-color: hsl(60, 10%, 96%) !important;
  // color: rgba(135, 139, 149, 1) !important;
  color: rgba(48, 56, 74, 1);
  font-size: 16px !important;
  padding-right: 16px !important;
  padding-left: 16px !important;

  max-width: 100%; // Ensures the input doesn't grow beyond its container
  overflow: hidden; // Hide any content that gets too big for the input
  text-overflow: ellipsis; // Show an ellipsis when the text is too long
  white-space: nowrap;
}

.media-content {
  display: flex;
  flex-wrap: wrap;
  font-size: 10px !important;
}

.custom-label-flyer {
  position: absolute;
  top: 50%;
  left: 16px;
  top: 4px;
  font-size: 12px;
  color: #5b626f;
}

.clear-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: grey;
  cursor: pointer;
}

//Mobile number field styling below
.vue-tel-input {
  background-color: white !important;
  height: 64px !important;
  width: 100% !important;
  border-radius: 8px !important;
  border: 2px solid #d1d2d6 !important;
}

.vti__dropdown-list {
  width: 360% !important;
  position: absolute !important;
  top: calc(100% + 4px) !important;
  background: white !important;
  overflow-y: auto !important;
  border-radius: 8px !important;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05), 
              0px 4px 4px -1px rgba(0, 0, 0, 0.05),
              0px 12px 16px -8px rgba(0, 0, 0, 0.18) !important;
  z-index: 9999 !important;
}

.vti__input-container {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 !important;
}

.vti__input {
  background: transparent !important;
  border: none !important;
  height: 100% !important;
  padding: 16px !important;
  margin: 0 !important;
  font-family: "Inter" !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  color: #30384a !important;
  width: 100% !important;
}

.vti__input:focus,
.vti__input:active,
.vue-tel-input:focus-within {
  outline: none !important;
  box-shadow: none !important;
}

.vti__dropdown {
  height: 100% !important;
  min-width: 90px !important;
  padding: 8px 16px !important;
  border-right: 2px solid #d1d2d6 !important;
  margin: 0 !important;
}

.vti__input::placeholder {
  font-family: "Inter" !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  color: #878b95 !important;
}
//end of mobile number field styling

</style>
